import {
  clearDfpAdsFromRefreshableList,
  incrementAdsCounter,
} from 'helpers/ads/redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { getCookie } from './cookies';
// import fireMonetizationDetailEvent from './fireMonetizationDetailEvent';

import {
  TOI_LIVE_DOMAIN,
  TOI_DEV_DOMAIN,
  TOI_DEV_MOBILE_DOMAIN,
  TOI_LIVE_MOBILE_DOMAIN,
  GOOGLE_WEBCACHE_DOMAIN,
  ACTIVE_PRIME_USER_PRC_ARR,
  PRC_FOR_FTU,
  MOB_DEFAULT_INTERSTITIAL_URL_PROD,
  MOB_DEFAULT_INTERSTITIAL_URL_DEV,
  MOB_DEFAULT_INTERSTITIAL_US_URL_DEV,
  MOB_DEFAULT_INTERSTITIAL_US_URL_PROD,
  IPL_MID_ARTICLE,
  BANNER_MID_ARTICLE,
  PROMOTED_AMAZON_SLIDER,
  FIVE_MINUTES,
  SIX_HOURS,
  PAID_ARTICLE_PRIME_ID,
  FREE_ARTICLE_PRIME_ID,
  GRXID_ABSENT_ERROR_CODE,
  GRXID_ABSENT_ERROR_MESSAGE,
  CD_TYPE_GA_AND_GRX,
  TOI_S2S_LIVE_DOMAIN,
  TOI_S2S_LIVE_MOBILE_DOMAIN,
  JARVIS_FEED_URL,
  JARVIS_PVT_FEED_URL,
  JARVIS_CACHE_BY_PASS,
  FREE_ARTICLE_PRIME_ID_NUMBER,
  PAID_ARTICLE_PRIME_ID_NUMBER,
  // NEW_PLANPAGE_URL,
} from '../constants';
import { getPrcCookieValue } from './primeUtil';

export function createSlug(inputString, overrideValues = false) {
  if (!inputString) {
    return inputString;
  }
  let stateMap = {
    'andaman-and-nicobar-islands': 'andaman-nicobar-islands',
    'jammu-and-kashmir': 'jammu-kashmir',
    'nct-of-delhi': 'delhi',
    'dadra-and-nagar-haveli': 'dadra-nagar-haveli',
    'daman-and-diu': 'daman-diu',
  };
  const override = {
    delhi: 'new-delhi',
  };
  if (overrideValues) {
    stateMap = { ...stateMap, ...override };
  }
  let slug = inputString.trim().toLowerCase();
  slug = slug.replace(/_/g, '-');
  slug = slug.replace(/\./g, '-');
  slug = slug.replace(/\s+/g, '-');
  slug = slug.replace(/[^a-z0-9-]/g, '');
  slug = slug.replace(/-+/g, '-');
  slug = slug.replace(/-st$/i, '');
  slug = slug.replace(/-sc$/i, '');
  if (stateMap[slug]) {
    return stateMap[slug];
  }
  // Remove first and last special character if they exist
  slug = slug.replace(/^[-_.]|[-_.]$/g, '');
  return slug;
}

export function formatPrice(amount) {
  const numericAmount = parseFloat(amount);
  if (isNaN(numericAmount)) {
    return numericAmount;
  }

  // Convert the number to a string with two decimal places
  let formattedAmount = numericAmount.toFixed(2);

  // If the number is a whole number, remove the .00 part
  if (numericAmount % 1 === 0) {
    formattedAmount = numericAmount.toFixed(0);
  }

  // Add commas for thousands

  formattedAmount = formattedAmount.replace(
    /(\d)(?=(\d\d)+\d(\.\d*)?$)/g,
    '$1,',
  );

  // Return the formatted amount with the currency symbol
  return formattedAmount;
}

export function randomNum() {
  const timestamp = Date.now();
  return Math.floor(timestamp * 1000);
}

export function addTimeParameterInUrl(url) {
  if (url) {
    return `${url}?t=${randomNum()}`;
  }
  return url;
}

export const getQueryParams = (paramName, url) => {
  const { href = '' } = url || window.location;
  const reg = new RegExp(`[?&]${paramName}=([^&#]*)`, 'i');
  const queryString = reg.exec(href);
  return queryString ? queryString[1] : null;
};
export function getStringToLowerCase(val) {
  let data = val;
  if (val) {
    if (val && typeof val === 'string') {
      data = val.replace(/\s+/g, '_').toLowerCase();
    }
  } else {
    data = 'N/A';
  }
  return data;
}

export function sanitizeSectionName(val) {
  let data = val;
  if (val && typeof val === 'string') {
    if (val === 'life-style' || val.includes('lifestyle')) {
      data = 'life_style';
    } else {
      data = val.replace(/-/g, '_');
    }
  }
  return data;
}

export function convertToKebabCase(str) {
  if (!str || typeof str !== 'string') return str;
  return str
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters except hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .trim();
}

export function modifyNestedObjects(obj, key, val, newVal) {
  const newValue = newVal;
  // eslint-disable-next-line no-restricted-syntax
  for (const i in obj) {
    if (typeof obj[i] === 'object') {
      modifyNestedObjects(obj[i], key, val, newValue);
    } else if (i === key && obj[key] === val) {
      obj[key] = newValue;
    }
  }
  return obj;
}

export function debounce(func, wait, immediate) {
  let timeout;
  return function debouncer() {
    const context = this;
    const args = arguments;
    const later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
export const insertAtIndexInArray = (myArray, index, item) => {
  if (myArray instanceof Array) {
    myArray.splice(index, 0, item);
    return myArray;
  }
  return myArray;
};

export const getValueBeforeDecimal = numberStringWithCommas => {
  if (
    typeof numberStringWithCommas === 'string' &&
    numberStringWithCommas.indexOf('.') > -1
  ) {
    return numberStringWithCommas.substring(
      0,
      numberStringWithCommas.indexOf('.'),
    );
  }

  return numberStringWithCommas;
};

export function getSiteDomain(isMobile) {
  const isDev = !__PROD__;
  if (isMobile) {
    return isDev ? TOI_DEV_MOBILE_DOMAIN : TOI_LIVE_MOBILE_DOMAIN;
  }

  return isDev ? TOI_DEV_DOMAIN : TOI_LIVE_DOMAIN;
}

export function getS2Sdomain(isMobile) {
  const isDev = !__PROD__;
  if (isMobile) {
    return isDev ? TOI_DEV_MOBILE_DOMAIN : TOI_S2S_LIVE_MOBILE_DOMAIN;
  }

  return isDev ? TOI_DEV_DOMAIN : TOI_S2S_LIVE_DOMAIN;
}

export function getMobDefaultInterstitialDomain() {
  const isDev = !__PROD__;
  return isDev
    ? MOB_DEFAULT_INTERSTITIAL_URL_DEV
    : MOB_DEFAULT_INTERSTITIAL_URL_PROD;
}
export function getUsMobDefaultInterstitialDomain() {
  const isDev = !__PROD__;
  return isDev
    ? MOB_DEFAULT_INTERSTITIAL_US_URL_DEV
    : MOB_DEFAULT_INTERSTITIAL_US_URL_PROD;
}

export function getNavigationPath(path, depth) {
  const navigationPath = path
    .split('/')
    .slice(0, depth + 1)
    .join('/');

  return navigationPath;
}
export function sanitizeQueryParams(paramsObj) {
  const sanitizedParamsObj = {};

  // loop through params keys, if value is array, pick its last value as param's value
  Object.keys(paramsObj).forEach(paramKey => {
    const paramValue = paramsObj[paramKey];
    if (Array.isArray(paramValue)) {
      sanitizedParamsObj[paramKey] = paramValue[paramValue.length - 1];
    } else {
      sanitizedParamsObj[paramKey] = paramValue;
    }
  });

  return sanitizedParamsObj;
}

export function disableAppInit() {
  return (
    window.location.hostname === GOOGLE_WEBCACHE_DOMAIN ||
    window.document.domain === GOOGLE_WEBCACHE_DOMAIN
  );
}

export function getBreadCrumbData(navBreadCrumbData) {
  const breadCrumbDataList =
    Array.isArray(Object.values(navBreadCrumbData)) &&
    Object.values(navBreadCrumbData).length > 0
      ? Object.values(navBreadCrumbData).map((node = {}) => {
          const keys = Object.keys(node);

          const nameKey = Array.isArray(keys)
            ? keys.find(k => k.startsWith('subsecname'))
            : null;
          const overrideKey = Array.isArray(keys)
            ? keys.find(k => k.startsWith('overridelink'))
            : null;
          const label = node?.[nameKey] || '';
          const override =
            typeof node?.[overrideKey] === 'string' ? node[overrideKey] : '';
          const link = override.trim() ? override : '';
          return { label, link };
        })
      : [];
  return breadCrumbDataList;
}

// Utility function to approximate large numbers and add commas
export function approximateNumberConvert(number) {
  if (number < 1000) {
    return number.toString(); // No need to approximate
  } else if (number < 1e6) {
    return `${(number / 1000).toFixed(0)}k`; // Approximate in thousands
  } else if (number < 1e9) {
    return `${(number / 1e6).toFixed(0)}m`; // Approximate in millions
  } else if (number < 1e12) {
    return `${(number / 1e9).toFixed(0)}b`; // Approximate in billions
  }
  return `${(number / 1e12).toFixed(0)}t`; // Approximate in trillions
}

export function toQueryString(obj) {
  const parts = [];
  Object.keys(obj).forEach(i => {
    parts.push(`${encodeURIComponent(i)}=${encodeURIComponent(obj[i])}`);
  });
  return parts.join('&');
}

export function routeChangeHandlings(context, isInitialRender) {
  window.ctn_res = null;
  context.store.dispatch(clearDfpAdsFromRefreshableList());
  if (!isInitialRender) {
    context.store.dispatch(incrementAdsCounter());
  }
}
export function userVideoDataJson(oldData) {
  const updatedJson = { data: { items: [] } };
  if (oldData && oldData.data) {
    oldData.data.forEach(item => {
      if (item.msid) {
        let views = '';
        if (oldData.views && oldData.views.msid) {
          if (parseInt(oldData.views.msid, 10) === parseInt(item.msid, 10)) {
            views = oldData.views.viewed;
          }
        } else {
          const viewObj = oldData.views
            ? oldData.views.find(
                o => parseInt(o.msid, 10) === parseInt(item.msid, 10),
              )
            : null;
          views = (viewObj && viewObj.viewed) || '';
        }
        updatedJson.data.items.push({
          id: item.msid,
          hl: item.tet,
          imageid: item.msid,
          wu: item.teu,
          _id: item._id,
          views,
        });
      }
    });
  }
  return updatedJson;
}

export function rodate(time = '') {
  const getElapsedTime = (ctime, labels_config, last_only) => {
    if (typeof ctime !== 'number') {
      return '';
    }
    const labels_default = {
      year: 'year',
      day: 'day',
      hour: 'hour',
      minute: 'minute',
      second: 'second',
      ago: 'ago',
    };
    const labels = Object.assign({}, labels_default, labels_config);
    const timeparts = [
      {
        name: labels.year,
        div: 31536000000,
        mod: 10000,
      },
      {
        name: labels.day,
        div: 86400000,
        mod: 365,
      },
      {
        name: labels.hour,
        div: 3600000,
        mod: 24,
      },
      {
        name: labels.minute,
        div: 60000,
        mod: 60,
      },
      {
        name: labels.second,
        div: 1000,
        mod: 60,
      },
    ];
    let i = 0;
    const l = timeparts.length;
    let calc;
    const values = [];
    const interval = new Date().getTime() - ctime; //todo use server time
    while (i < l) {
      calc = Math.floor(interval / timeparts[i].div) % timeparts[i].mod;
      if (calc && calc >= 0) {
        values.push(`${calc} ${timeparts[i].name}${calc > 1 ? 's' : ''}`);
      }
      i += 1;
    }
    if (values.length === 0) {
      values.push(`1 ${labels.second}`);
    }
    if (last_only === true) {
      return `${values[0]} ${labels.ago}`;
    }
    return `${values.join(', ')} ${labels.ago}`;
  };

  let elapsedTime = '';

  let finalTime = time;
  if (typeof finalTime !== 'string') {
    finalTime = finalTime.toString();
  }
  let match = finalTime.match(/^(\d+)-(\d+)-(\d+) (\d+)\:(\d+)\:(\d+)$/);
  let rod = new Date(finalTime);

  if (!!finalTime && !match && Number.isNaN(rod.getTime())) {
    // console.log(finalTime);
    finalTime = !Number.isNaN(finalTime) ? parseInt(finalTime, 10) : finalTime;
    const timeObj = new Date(finalTime);
    if (!Number.isNaN(timeObj.getTime())) {
      rod = timeObj;
    } else if (typeof finalTime === 'string') {
      if (finalTime.indexOf('hrs IST') !== -1) {
        finalTime = finalTime.replace(' hrs IST', '');
        finalTime = finalTime.splice(-2, 0, ':'); //21 Apr, 2014, 16:31
      }
      finalTime = finalTime.replace('IST', '');
      finalTime = finalTime.replace('hrs', '');
      finalTime = finalTime.replace('AM', ' AM');
      finalTime = finalTime.replace('PM', ' PM');
      rod = new Date(finalTime);
      if (Number.isNaN(rod.getTime())) {
        if (finalTime.indexOf(':') > -1) {
          finalTime = finalTime.split(' ').join('T');
          finalTime = finalTime.concat('+05:30');
          rod = new Date(finalTime);
        }
      }
    }
  }
  match = [
    '',
    rod.getYear() + 1900,
    rod.getMonth() + 1,
    rod.getDate(),
    rod.getHours(),
    rod.getMinutes(),
    rod.getSeconds(),
  ];
  if (!!match && match instanceof Array && match.length >= 6) {
    elapsedTime = getElapsedTime(
      new Date(
        match[1],
        match[2] - 1,
        match[3],
        match[4],
        match[5],
        match[6],
      ).getTime(),
      {
        minute: 'min',
        second: 'sec',
      },
      true,
    );
  }

  return elapsedTime;
}

export function getClassesFromArray(styleArr, styleObj) {
  //classArr is array and checking length before processing
  if (styleArr.length) {
    const classArr = [];
    for (let i = 0; i < styleArr.length; i += 1) {
      classArr[i] = styleObj[styleArr[i]];
    }
    return classArr.join(' ');
  }
  return '';
}

export function getCustomClassesForPayload(classes, styleObj) {
  //Claases is string and checking length before processing
  if (classes.length) {
    const newClass = classes.replace(/  +/g, ' ');
    const classArr = newClass.split(' ');
    for (let i = 0; i < classArr.length; i += 1) {
      classArr[i] = styleObj[classArr[i]];
    }
    return classArr.join(' ');
  }
  return '';
}

export function preventCopy(isWapView, utm) {
  const d = document;
  const b = d.body;
  // const de = d.documentElement;
  // eslint-disable-next-line no-eval
  const C = eval('/*@cc_on!@*/false');
  const _ga_utm = `utm_source=contentofinterest&utm_medium=text&utm_campaign=${
    utm && utm.length > 0 ? utm : 'cppst'
  }`;
  let AE;
  // eslint-disable-next-line no-unused-vars
  let RE;
  // eslint-disable-next-line no-shadow
  const sp = (a, b) => {
    Object.assign(b, a);
    // for (const c in a) if (a.hasOwnProperty(c)) b[c] = a[c];
  };
  const bo = (a, be, c) => {
    const ae = d.createElement(a);
    sp(be, ae);
    sp(c, ae.style);
    return ae;
  };
  const tc = () => {
    let so;
    let st = '';
    const reg1 = /\w+/gi;
    let linkFlg = true;
    if (window._gaq) {
      window._gaq.push(['_trackEvent', 'cppst', 'select', 'cntntcp']);
    }
    if (d.selection && d.selection.createRange) {
      so = d.selection.createRange();
      st = so.htmlText;
      if (st.match(reg1) && st.match(reg1).length > 4) {
        linkFlg = true;
        st = st.replace(/(<a([^>]+)>)/gi, '');
        st = st.replace(/(<([^>]+)a>)/gi, '');
        st = st.length > 60 ? `${st.substring(0, 60)}&nbsp;..` : st;
        st = st.replace(/\n/gi, '<br />');
        st += '<br />';
      }
    } else {
      so = window.getSelection();
      st = so.toString();
      if (st.match(reg1) && st.match(reg1).length > 4) {
        if (so.rangeCount) {
          const container = bo(
            'div',
            { id: 'copiedTextClone' },
            { display: 'none' },
          );
          linkFlg = true;
          const len = so.rangeCount;
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < len; ++i) {
            container.appendChild(so.getRangeAt(i).cloneContents());
          }
          st = container.innerHTML;
          st = st.replace(/(<a([^>]+)>)/gi, '');
          st = st.replace(/(<([^>]+)a>)/gi, '');
          st = st.length > 60 ? `${st.substring(0, 60)}&nbsp;..` : st;
        }
      }
    }
    let lnkurl = window.location.href;
    const indx2 = lnkurl.indexOf('/articleshow');
    lnkurl = `http://${
      isWapView ? 'm.timesofindia.com' : 'timesofindia.indiatimes.com'
    }${lnkurl.substring(indx2, lnkurl.length)}`;
    lnkurl =
      // eslint-disable-next-line no-nested-ternary
      lnkurl.indexOf('?') === -1
        ? `${lnkurl}?${_ga_utm}`
        : lnkurl.indexOf(_ga_utm) === -1 ? `${lnkurl}&${_ga_utm}` : lnkurl;
    if (linkFlg) {
      const lnk = `<br /><br /><div style='font-size:12px;'>Read more at:<br /><a href='${lnkurl}'>${lnkurl}</a></div>`;
      st = `${st} ${lnk}`;
    }
    const e = bo(
      'div',
      {},
      { position: 'fixed', top: 0, left: '-99999px', background: '#fff' },
    );
    b.appendChild(e);
    e.innerHTML = st;
    if (so.selectAllChildren) {
      so.selectAllChildren(e);
    } else {
      const m = b.createTextRange();
      m.moveToElementText(e);
      m.select();
    }
    window.setTimeout(() => {
      b.removeChild(e);
    }, 0);
  };
  const ca = a => {
    // eslint-disable-next-line no-use-before-define
    SE();
    // eslint-disable-next-line no-unused-expressions
    d.readyState === 'complete'
      ? a()
      : AE(window, 'load', () => {
          setTimeout(() => {
            if (typeof d.readyState === 'undefined' && !C)
              d.readyState = 'complete';
            a();
          }, 10);
        });
  };
  let SE = () => {
    if (window.addEventListener) {
      AE = (a, be, c) => {
        a.addEventListener(be, c, false);
      };
      RE = (a, be, c) => {
        a.removeEventListener(be, c, false);
      };
    } else {
      AE = (a, be, c) => {
        a.attachEvent(`on${be}`, c);
      };
      RE = (a, be, c) => {
        a.detachEvent(`on${be}`, c);
      };
    }
  };
  const init = () => {
    if (window.addEventListener) {
      b.addEventListener('copy', tc);
    } else {
      b.attachEvent('oncopy', tc);
    }
  };
  return ca(init);
}

export function convertHtmlToStringText(cmt) {
  if (typeof document === 'undefined') {
    return cmt;
  }
  const elem = document.createElement('div');
  elem.innerHTML = cmt;
  return elem.innerText;
}

export function isTablet() {
  return (function returnAgent(agent) {
    return /(?:ipad|tab)/i.test(agent);
  })(navigator.userAgent || navigator.vendor || window.opera);
}

export function isLandscape() {
  if (typeof window !== 'undefined') {
    const mql = window.matchMedia('(orientation: landscape)');
    return mql.matches;
  }
  return false;
}

export function isIOS() {
  return (function returnAgent(agent) {
    return /iPhone|iPod|iPad/.test(agent);
  })(navigator.userAgent || navigator.vendor || window.opera);
}

export function isIE11() {
  return navigator.userAgent.match(/Trident.*rv[ :]*11\./);
}

export function isIE() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/') || ua.indexOf('Edg/'); //In latest versions of Edge 88+, comes Edg in ua
  const newEdge = ua.indexOf('Edg/');
  if (edge > 0 || newEdge > 0) {
    // Edge (IE 12+) => return version number
    if (newEdge) {
      return parseInt(ua.substring(newEdge + 5, ua.indexOf('.', newEdge)), 10);
    }
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

export function getBrowserName() {
  let browser = '';
  if (typeof window !== 'undefined') {
    const { userAgent } = navigator;
    // console.log('====== userAgent : ', userAgent);
    if (isIE()) {
      browser = 'IE';
    } else if (
      userAgent.indexOf('Chrome') > -1 ||
      userAgent.indexOf('CriOS') > -1
    ) {
      browser = 'Chrome';
    } else if (userAgent.indexOf('Firefox') > -1) {
      browser = 'Firefox';
    } else if (userAgent.indexOf('Safari') > -1) {
      browser = 'Safari';
    } else if (
      userAgent.indexOf('Opera') > -1 ||
      userAgent.indexOf('OPR') > -1
    ) {
      browser = 'Opera';
    }
  }
  return browser;
}

export function inViewForReact(el, skew = 0, partial, roundValues) {
  const rect = el.getBoundingClientRect();
  let { top, bottom } = rect;
  let { height } = rect;
  let { left, right } = rect;
  if (roundValues) {
    top = Math.round(top);
    height = Math.round(height);
    left = Math.round(left);
    right = Math.round(right);
  }
  let isInView = false;
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  if (skew) {
    top = skew ? top + skew / 2 : top;
    bottom = skew ? bottom - skew / 2 : bottom;
  }

  if (partial) {
    isInView =
      (bottom > 0 && bottom <= windowHeight) ||
      (bottom > 0 && bottom < height) ||
      (top >= 0 && top <= windowHeight);
  } else {
    isInView =
      top >= 0 && left >= 0 && bottom <= windowHeight && right <= windowWidth;
  }
  return isInView;
}
export const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export function loadFacebookJs(onLoadCallback) {
  if (typeof document !== 'undefined') {
    if (typeof window.FB !== 'undefined') {
      if (typeof onLoadCallback === 'function') {
        onLoadCallback();
      }
      return;
    }
    const s = document.createElement('script');
    s.setAttribute('src', `//connect.facebook.net/en_US/sdk.js`);
    s.onload = () => {
      window.FB.init({
        appId: 898459706886386,
        status: false,
        cookie: true,
        xfbml: false,
        version: 'v10.0',
      });
      if (typeof onLoadCallback === 'function') {
        onLoadCallback();
      }
    };
    document.body.appendChild(s);
  }
}

export function getMsidFromPath(path) {
  let msid = '';
  if (typeof path === 'string' && path.length > 0) {
    const articlePathSplit = path.split('/');
    if (
      articlePathSplit &&
      articlePathSplit.length > 0 &&
      articlePathSplit[articlePathSplit.length - 1].includes('.cms')
    ) {
      msid = articlePathSplit[articlePathSplit.length - 1].split('.')[0];
    }
  }

  return msid;
}

export function getContentTypeForPath(path) {
  let contentType = '';
  if (typeof path === 'string' && path.length > 0) {
    const articlePathSplit = path.split('/');
    if (
      articlePathSplit &&
      articlePathSplit.length > 0 &&
      articlePathSplit[articlePathSplit.length - 1].includes('.cms')
    ) {
      contentType = articlePathSplit[articlePathSplit.length - 2];
    }
  }
  return contentType;
}

export function convertTeamName(name) {
  const teamsMap = {
    CSK: 'Chennai Super Kings',
    DD: 'Delhi Daredevils',
    DC: 'Delhi Capitals',
    KKR: 'Kolkata Knight Riders',
    MI: 'Mumbai Indians',
    PBKS: ['Punjab Kings', 'Punjab Kings XI'],
    RCB: ['Royal Challengers Bangalore', 'Royal Challengers Bengaluru'], // Store as array
    SRH: 'Sunrisers Hyderabad',
    GT: 'Gujarat Titans',
    LSG: 'Lucknow Super Giants',
    KTK: 'Kochi Tuskers Kerala',
    PWI: 'Pune Warriors India',
    RPS: 'Rising Pune Supergiant',
    // KXIP: 'Punjab Kings XI',
    RR: 'Rajasthan Royals',
    GL: 'Gujarat Lions',
  };

  // Create reverse lookup map
  const reverseTeamsMap = {};
  Object.entries(teamsMap).forEach(([short, full]) => {
    if (Array.isArray(full)) {
      full.forEach(teamName => {
        reverseTeamsMap[teamName] = short;
      });
    } else {
      reverseTeamsMap[full] = short;
    }
  });

  return teamsMap[name] || reverseTeamsMap[name] || name;
}

export function getShortUrl(url, type, isMobile, disableShortUrl = false) {
  if (!url) {
    return '';
  }

  // TOIPR-54913 For sharing home page url without appending anything for budget
  if (disableShortUrl) {
    return url;
  }
  if (!disableShortUrl) {
    return url;
  }

  // this.utmCampaignM = 'j';
  //   this.utmCampaignD = 'k';
  const shortUrlMap = {
    fb: {
      utmSource: 'a23',
      medium: 'g',
    },
    twitter: {
      utmSource: 'a24',
      medium: 'g',
    },
    linkedin: {
      utmSource: 'a26',
      medium: 'g',
    },
    whatsapp: {
      utmSource: 'a31',
      medium: 'g',
    },
    whatsappfloating: {
      utmSource: 'a31',
      medium: 'g',
      campaign: 'a8',
    },
    email: {
      utmSource: 'a28',
      medium: 'g',
    },
    pinit: {
      utmSource: 'a27',
      medium: 'g',
    },
    nativeShare: {
      utmSource: 'a33',
      medium: 'g',
    },
  };

  const mapValue = shortUrlMap[type];
  if (!mapValue) {
    return url;
  }
  return `${url}/${mapValue.utmSource}${mapValue.medium}${mapValue.campaign ||
    (isMobile ? 'j' : 'k')}`;
}

export function getAuthors(authors) {
  let author = '';
  if (authors && authors.length > 0) {
    for (let i = 0; i < authors.length; i += 1) {
      author += authors[0].name;
      if (!author.length === 1 && i !== author.length - 1) {
        author += '&';
      }
    }
  }

  return author;
}

/**
 * Get Authors Name
 * @param {Array} authorData
 * @returns {string}
 */

export function getAuthorsName(authorData) {
  let authorName = '';
  if (authorData && Array.isArray(authorData) && authorData.length > 0) {
    const author = authorData[0]?.name || '';
    authorName =
      author && typeof author === 'string'
        ? author.replace(/\s+/g, '_').toLowerCase()
        : '';
  }
  return authorName;
}

export function isPrimeUser() {
  const activePrimeUserPrcArr = ACTIVE_PRIME_USER_PRC_ARR;
  const prc = getCookie('prc');
  let prcVal = -1;
  if (prc && prc.length > 0) {
    prcVal = parseInt(prc.split('#')[0], 10);
  }
  if (
    typeof prcVal !== 'undefined' &&
    activePrimeUserPrcArr.indexOf(prcVal) > -1
  ) {
    return true;
  }
  return false;
}

export function checkIfPaidStory(msid) {
  return (
    (sessionStorage?.getItem('paidstories')?.length > 0 &&
      sessionStorage
        ?.getItem('paidstories')
        ?.split(',')
        .indexOf(msid) > -1) ||
    (sessionStorage?.getItem('paidCredstories')?.length > 0 &&
      sessionStorage
        ?.getItem('paidCredstories')
        ?.split(',')
        .indexOf(msid) > -1)
  );
}

export function reloadWrtPrimeUnlock() {
  if (__PROD__) {
    window.location.reload();
  } else {
    let url = window.location.href;
    if (!(url.indexOf('frmprime=yes') > -1)) {
      if (url.indexOf('?') > -1) {
        url += '&frmprime=yes';
      } else {
        url += '?frmprime=yes';
      }

      window.location.href = url;
    }
  }
}

export function reloadIfPaidStory(msid) {
  if (checkIfPaidStory(msid)) {
    reloadWrtPrimeUnlock();
  }
}

export function isFTU() {
  const prc = getCookie('prc');
  let _isFTU = false;
  if (prc && prc.length > 0) {
    const prcVal = parseInt(prc.split('#')[0], 10);
    _isFTU = prcVal === PRC_FOR_FTU;
  }
  return _isFTU;
}

export function getSectionsListFromBreadCrumb(navData = []) {
  const subSectionsArray = [];
  for (let i = 0; i < navData.length; i += 1) {
    if (navData[i].id !== 'home' && navData[i].id !== 'title') {
      subSectionsArray.push(navData[i].label);
    }
  }
  return subSectionsArray;
}
export function getCustomDimension8(sectionsNameList = []) {
  // console.log('check the array ' + sectionsNameList.join('*'));
  if (sectionsNameList.length > 0) {
    if (sectionsNameList[0].toLowerCase() === 'videos' && sectionsNameList[1]) {
      return sectionsNameList[1];
    }
    return sectionsNameList[0];
  }
  return '';
}

export function disableBodyScroll() {
  const $body = document.getElementsByTagName('body')[0];
  let classList = $body.className;
  const classListArr = classList ? classList.split(' ') : [];
  if (classListArr.indexOf('disable-scroll') !== -1) {
    return;
  }
  classListArr.push('disable-scroll');
  classList = classListArr.join(' ');
  $body.className = classList;
}
export function enableBodyScroll() {
  const $body = document.getElementsByTagName('body')[0];
  let classList = $body.className;
  const classListArr = classList ? classList.split(' ') : [];
  const disableArrayIndex = classListArr.indexOf('disable-scroll');
  if (disableArrayIndex === -1) {
    return;
  }
  classListArr.splice(disableArrayIndex, 1);
  classList = classListArr.join(' ');
  $body.className = classList;
}
export function getDomainOnly(url) {
  return `.${(url || document.location.host)
    .split(':')[0]
    .split('.')
    .reverse()
    .slice(0, 2)
    .reverse()
    .join('.')}`;
}
export function isTouch() {
  return 'ontouchstart' in window || 'DocumentTouch' in window;
}

export function gtag() {
  window.dataLayer = window.dataLayer || [];

  if (window.dataLayer instanceof Array) {
    window.dataLayer.push(arguments);
  }
}

export function checkAndRedirectToHomePage(e) {
  const pageUrlPathName = window.location.pathname;
  if (pageUrlPathName === '/us') {
    e.preventDefault();
    window.location.href = pageUrlPathName;
    return false;
  }
  return true;
}

export function getGeoBasesPerpectualNextLinkData(nextLinks) {
  let finalNextLinks = [];
  if (nextLinks && nextLinks.length > 0 && nextLinks instanceof Array) {
    if (window.geoinfo && window.geoinfo.CountryCode === 'US') {
      finalNextLinks = nextLinks.map(
        data => (data.geo && data.geo.US ? data.geo.US : data),
      );
    } else {
      finalNextLinks = nextLinks;
    }
  }
  return finalNextLinks;
}

export function getSkipAdsFlagForVideo(meta, videoMeta) {
  if (meta && meta.AdServingRules === 'Turnoff Video Ads') {
    return true;
  }
  if (
    videoMeta &&
    ((videoMeta.AdServingRules &&
      videoMeta.AdServingRules === 'Turnoff Video Ads') ||
      (videoMeta.SpecialID && videoMeta.SpecialID === 'noad'))
  ) {
    return true;
  }
  return false;
}

export function isIPLMidArticleWidgetsPresent(
  articleshowData,
  itemTypeKey = 'tn',
) {
  const { widgets } = articleshowData;
  let isIPLMidArticleWidgetPresent = false;
  if (widgets && widgets instanceof Array) {
    for (let i = 0; i < widgets.length; i += 1) {
      if (widgets[i] && widgets[i][itemTypeKey] === IPL_MID_ARTICLE) {
        isIPLMidArticleWidgetPresent = true;
        break;
      }
    }
  }
  return isIPLMidArticleWidgetPresent;
}

export function isBannerMidArticleWidgetsPresent(
  articleshowData,
  itemTypeKey = 'tn',
) {
  const { widgets } = articleshowData;
  let isBannerMidArticleWidgetPresent = false;
  if (widgets && widgets instanceof Array) {
    for (let i = 0; i < widgets.length; i += 1) {
      if (widgets[i] && widgets[i][itemTypeKey] === BANNER_MID_ARTICLE) {
        isBannerMidArticleWidgetPresent = true;
        break;
      }
    }
  }
  return isBannerMidArticleWidgetPresent;
}

/**
 * function to get banner data
 * @param {*} widgets
 */
export function getBannerData(widgets) {
  let widget;
  for (let i = 0; i < widgets.length; i += 1) {
    if (widgets[i].tn === 'widget_election_banner') {
      widget = widgets[i];
      break;
    }
  }
  return widget;
}

export function getPlatformTemplateName(url, platform = 'web') {
  if (!url || typeof url !== 'string') return null; // Safe check

  const lowerUrl = url.toLowerCase();

  // Only execute if URL has "/elections"
  if (!lowerUrl.includes('/elections')) {
    return null; // Or return 'not_election_page'
  }
  switch (true) {
    case lowerUrl.includes('/constituency-show/'):
      return `${platform}_constituency_show`;

    case lowerUrl.includes('/results'):
      return `${platform}_election_result`;

    case lowerUrl.includes('/candidates'):
      return `${platform}_election_lisitng`;

    case lowerUrl.includes('/constituencies-list'):
      return `${platform}_election_lisitng`;

    case lowerUrl.includes('/exit-polls'):
      return `${platform}_exitpoll`;

    default:
      return `${platform}_election_result`;
  }
}

export function isSingleDomainPages(linkUrl) {
  let singleDomainShow = false;
  singleDomainShow =
    linkUrl &&
    (linkUrl.includes('/articleshow/') ||
      linkUrl.includes('/photostory/') ||
      linkUrl.includes('/movie-review/') ||
      linkUrl.includes('/movieshow/') ||
      linkUrl.includes('/seasonreview/') ||
      linkUrl.includes('/ottmoviereview/') ||
      linkUrl.includes('/episodereview/') ||
      linkUrl.includes('/seriesreview/'));

  const singleDomainVideohow =
    linkUrl &&
    (linkUrl.includes('/videoshow/') || linkUrl.includes('/videos/'));
  const singleDomainL2 =
    linkUrl &&
    (linkUrl.includes('/topic/') ||
      linkUrl.includes('/city/') ||
      linkUrl.includes('/videos/') ||
      linkUrl.includes('/education/') ||
      linkUrl.includes('/astrology/') ||
      linkUrl.includes('/religion/') ||
      linkUrl.includes('/sports/') ||
      linkUrl.includes('/speaking-tree/') ||
      linkUrl.includes('/classifieds/') ||
      linkUrl.includes('/auto/') ||
      linkUrl.includes('/business/') ||
      linkUrl.includes('/india/') ||
      linkUrl.includes('/world/') ||
      linkUrl.includes('/elections/') ||
      linkUrl.includes('/spotlight/') ||
      linkUrl.includes('/nri/') ||
      linkUrl.includes('/podcasts/') ||
      linkUrl.includes('/cartoons/') ||
      linkUrl.includes('/cartoonshow/') ||
      linkUrl.includes('/amazon-bestsellers/') ||
      linkUrl.includes('/briefs/') ||
      linkUrl.includes('/politics/') ||
      linkUrl.includes('/viral-news/') ||
      linkUrl.includes('/news/') ||
      linkUrl.includes('/technology/') ||
      linkUrl.includes('/defence/') ||
      linkUrl.includes('/health/') ||
      linkUrl.includes('/legal/') ||
      linkUrl.includes('/real-estate/') ||
      linkUrl.includes('/good-news/') ||
      linkUrl.includes('/relationship/') ||
      linkUrl.includes('/gadgets-news/') ||
      linkUrl.includes('/etimes/') ||
      linkUrl.includes('/entertainment/') ||
      linkUrl.includes('/life-style/') ||
      linkUrl.includes('/web-series/') ||
      linkUrl.includes('/science/') ||
      linkUrl.includes('/toireporter/') ||
      linkUrl.includes('/games/') ||
      linkUrl.includes('/etmoviedetaillisting/') ||
      linkUrl.includes('/most-searched-products/') ||
      linkUrl.includes('/live-tv/') ||
      linkUrl.includes('/toi/') ||
      linkUrl.includes('/tv/'));

  let singleDomainListing = false;
  singleDomainListing =
    linkUrl &&
    (linkUrl === '/' ||
      linkUrl === '/us' ||
      linkUrl.startsWith('/?') ||
      linkUrl.startsWith('/us?') ||
      linkUrl === '/city' ||
      linkUrl === '/city?cs=t' ||
      linkUrl === `${TOI_LIVE_DOMAIN}/city` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/city?cs=t` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/city` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/city?cs=t` ||
      linkUrl === '/sports' ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/sports` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/sports` ||
      linkUrl === '/tv' ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/tv` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/tv` ||
      linkUrl === `/religion` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/religion` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/religion` ||
      linkUrl === `/education` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/education` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/education` ||
      linkUrl === `/astrology` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/astrology` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/astrology` ||
      linkUrl === `/gadgets-news` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/gadgets-news` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/gadgets-news` ||
      linkUrl === `/hot-picks` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/hot-picks` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/hot-picks` ||
      linkUrl === `/sports` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/sports` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/sports` ||
      linkUrl === `/speaking-tree` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/speaking-tree` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/speaking-tree` ||
      linkUrl === `/classifieds` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/classifieds` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/classifieds` ||
      linkUrl === `/auto` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/auto` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/auto` ||
      linkUrl === `/business` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/business` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/business` ||
      linkUrl === `/defence` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/defence` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/defence` ||
      linkUrl === `/health` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/health` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/health` ||
      linkUrl === `/legal` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/legal` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/legal` ||
      linkUrl === `/real-estate` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/real-estate` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/real-estate` ||
      linkUrl === `/good-news` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/good-news` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/good-news` ||
      linkUrl === `/relationship` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/relationship` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/relationship` ||
      linkUrl === `/india` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/india` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/india` ||
      linkUrl === `/world` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/world` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/world` ||
      linkUrl === `/elections` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/elections` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/elections` ||
      linkUrl === `/spotlight` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/spotlight` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/spotlight` ||
      linkUrl === `/nri` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/nri` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/nri` ||
      linkUrl === `/podcasts` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/podcasts` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/podcasts` ||
      linkUrl === `/cartoons.cms` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/cartoons.cms` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/cartoons.cms` ||
      linkUrl === `/amazon-bestsellers` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/amazon-bestsellers` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/amazon-bestsellers` ||
      linkUrl === `/briefs` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/briefs` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/briefs` ||
      linkUrl === `/politics` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/politics` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/politics` ||
      linkUrl === `/viral-news` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/viral-news` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/viral-news` ||
      linkUrl === `/news` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/news` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/news` ||
      linkUrl === `/technology` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/technology` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/technology` ||
      linkUrl === `/etimes` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/etimes` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/etimes` ||
      linkUrl === `/entertainment` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/entertainment` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/entertainment` ||
      linkUrl === `/tv` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/tv` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/tv` ||
      linkUrl === `/life-style` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/life-style` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/life-style` ||
      linkUrl === `/travel` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/travel` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/travel` ||
      linkUrl === `/science` ||
      linkUrl === `${TOI_LIVE_DOMAIN}/science` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/science` ||
      linkUrl === '/videos' ||
      linkUrl === `${TOI_LIVE_DOMAIN}/videos` ||
      linkUrl === `${TOI_LIVE_MOBILE_DOMAIN}/videos`);

  const singleDomainShorttakes = linkUrl && linkUrl.includes('/short-videos/');

  return (
    singleDomainShow ||
    singleDomainListing ||
    singleDomainVideohow ||
    singleDomainL2 ||
    singleDomainShorttakes
  );
}

export function isPromotedAmazonSlidersPresent(
  articleshowData,
  itemTypeKey = 'tn',
) {
  const { widgets } = articleshowData;
  let isPromotedAmazonSliderPresent = false;
  if (widgets && widgets instanceof Array) {
    for (let i = 0; i < widgets.length; i += 1) {
      if (widgets[i] && widgets[i][itemTypeKey] === PROMOTED_AMAZON_SLIDER) {
        isPromotedAmazonSliderPresent = true;
        break;
      }
    }
  }
  return isPromotedAmazonSliderPresent;
}

/**
 * function to get query string value
 */
export function getParameterByName(name = '', url = window.location.href) {
  // const _name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  // const regex = new RegExp(`[?&]' + ${_name} + '(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * @param {*} el
 * Selected Element
 */
export function isScrolledIntoView(el) {
  const rect = el.getBoundingClientRect();
  const { top, bottom } = rect;

  // Only completely visible elements return true:
  // var isVisible = (elemTop >= 0 || elemBottom <= window.innerHeight);

  // Partially visible elements return true:
  const isVisible = top < window.innerHeight && bottom >= 0;
  return isVisible;
}

export function fireCustomDimension(
  value,
  dimension = 'dimension34',
  type = CD_TYPE_GA_AND_GRX, // by default 'gaAndGrx' will be fired
) {
  analyticsWrapper(type, 'set', dimension, value);
}

export function sortByKey(array, key) {
  return array.sort((a, b) => {
    const x = a[key];
    const y = b[key];
    if (x < y) {
      return -1;
    } else if (x > y) {
      return 1;
    }
    return 0;
  });
}

export function isGoogleBot() {
  if (
    typeof navigator === 'object' &&
    typeof navigator.userAgent === 'string' &&
    navigator.userAgent.toLowerCase().indexOf('googlebot') > -1
  ) {
    return true;
  }

  return false;
}

export const debugLogs = (logStr, val) => {
  if (
    typeof window === 'object' &&
    window.location.href.indexOf('debugLogs=1') > -1
  ) {
    console.log(logStr, val);
  }
};

export const isSafari = () => {
  if (
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') === -1 &&
    navigator.userAgent.indexOf('FxiOS') === -1
  ) {
    return true;
  }
  return false;
};

const getDocHeight = () => {
  const D = document;
  return Math.max(
    D.body.scrollHeight,
    D.documentElement.scrollHeight,
    D.body.offsetHeight,
    D.documentElement.offsetHeight,
    D.body.clientHeight,
    D.documentElement.clientHeight,
  );
};

export const percentageScrolled = () => {
  const winheight =
    window.innerHeight ||
    (document.documentElement || document.body).clientHeight;
  const docheight = getDocHeight();
  const scrollTop =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollTop;
  const trackLength = docheight - winheight;
  const pctScrolled = Math.floor(scrollTop / trackLength * 100);
  return pctScrolled;
};

export const compareStrings = (string1, string2) => {
  if (string1 && typeof string1 === 'string') {
    string1 = string1.toLowerCase();
  }
  if (string2 && typeof string2 === 'string') {
    string2 = string2.toLowerCase();
  }
  return string1 === string2;
};

export function setVariableForResizeObserver() {
  const ATF_WRAPPER_HEIGHT = document.querySelector('.ATF_wrapper')
    ? parseFloat(document.querySelector('.ATF_wrapper').offsetHeight)
    : 0;
  const ATF_MOBILE_ADS_PADDING =
    document.querySelector('.ATF_mobile_ads') &&
    document.querySelector('.ATF_mobile_ads').firstChild
      ? parseFloat(
          getComputedStyle(document.querySelector('.ATF_mobile_ads').firstChild)
            .paddingTop,
        ) +
        parseFloat(
          getComputedStyle(document.querySelector('.ATF_mobile_ads').firstChild)
            .paddingBottom,
        )
      : 0;
  return { ATF_WRAPPER_HEIGHT, ATF_MOBILE_ADS_PADDING };
}

/**
 * This is to try 20 times to initiate locateservice api,
 * locateservice js - /locateservice_js/version-12,minify-1.cms
 * locateservice api - //locate.indiatimes.com/service/locate
 * If not successfully loaded then stop trying after 20 trials
 */
const TRY_COUNT = 20;
export function initiateLocateService(callback) {
  // try 5 times to initiate the locate service
  let tryCount = 0;
  const st = setInterval(() => {
    tryCount += 1;
    if (
      typeof window !== 'undefined' &&
      window.locateservice &&
      typeof window.locateservice.initiate === 'function'
    ) {
      window.locateservice.initiate().then(res => {
        if (res === 'success') {
          if (typeof callback === 'function') {
            callback();
          }
        }
      });
      clearInterval(st);
    }
    if (tryCount === TRY_COUNT) {
      clearInterval(st);
    }
  }, 100);
}
export const setCacheTime = isPrime => (isPrime ? FIVE_MINUTES : SIX_HOURS);
export const isPrimeContent = primeId =>
  primeId === FREE_ARTICLE_PRIME_ID ||
  primeId === PAID_ARTICLE_PRIME_ID ||
  primeId === FREE_ARTICLE_PRIME_ID_NUMBER ||
  primeId === PAID_ARTICLE_PRIME_ID_NUMBER;

export const followUsLinksTwitter = {
  toi: 'https://twitter.com/timesofindia',
  business: 'https://twitter.com/toibusiness?s=21',
  city: 'https://twitter.com/toicitiesnews?s=21',
  world: 'https://twitter.com/toiworld?s=21',
  toiplus: 'https://twitter.com/TOIPlus',
  india: 'https://twitter.com/toiindianews?s=21',
  sports: 'https://twitter.com/toisports?s=21',
};
export const followUsLinksTelegram = {
  toi: 'https://t.me/Timesofindia_News',
};

export const followUsLinksFacebook = {
  toi: 'https://www.facebook.com/TimesofIndia/',
  business: 'https://www.facebook.com/toibusiness/',
  world: 'https://www.facebook.com/toiworldnews/',
  toiplus: 'https://www.facebook.com/TimesOfIndiaPlus/',
  sports: 'https://www.facebook.com/toisports/',
  india: 'https://www.facebook.com/TOIIndianews/',
};

export const followUsLinksInstagram = {
  toi: 'https://www.instagram.com/timesofindia/',
  sports: 'https://www.instagram.com/toi_sports/',
};
export const followUsLinksGoogle = {
  toi: 'https://news.google.com/publications/CAAqBwgKMM6y_Qowwu70Ag',
};

export const followUsLinksKoo = {
  toi: 'https://www.kooapp.com/profile/timesofindia',
  sports: 'https://www.kooapp.com/profile/TOISports',
};

export const followUsYoutube = {
  toi: 'https://www.youtube.com/timesofindia',
};
export const READ_ALSO_WIDGET_LINKS_URL =
  'https://toibnews.timesofindia.indiatimes.com/toi/artilceshow-gold-silver.htm';

const pageSections = {
  DEFAULT: 'toi',
  CITY: 'city',
  BUSINESS: 'business',
  WORLD: 'world',
  TOIPLUS: 'toiplus',
  INDIA: 'india',
  SPORTS: 'sports',
};

export const getSectionName = (
  articleListData,
  newsData,
  msid,
  liveblogData,
  breadcrumbData,
  isMobile = false,
) => {
  if (
    newsData &&
    newsData.navsubsecs &&
    newsData.navsubsecs.subsec1 &&
    newsData.navsubsecs.subsec1.subsecname1
  ) {
    const section = newsData.navsubsecs.subsec1.subsecname1.toUpperCase();
    return pageSections[section] ? pageSections[section] : pageSections.DEFAULT;
  }
  if (
    msid &&
    articleListData &&
    articleListData[msid] &&
    articleListData[msid].navsubsecs &&
    articleListData[msid].navsubsecs.subsec1 &&
    articleListData[msid].navsubsecs.subsec1.subsecname1
  ) {
    const section = articleListData[
      msid
    ].navsubsecs.subsec1.subsecname1.toUpperCase();
    return pageSections[section] ? pageSections[section] : pageSections.DEFAULT;
  }
  if (
    liveblogData &&
    liveblogData.navsubsecs &&
    liveblogData.navsubsecs.subsec1 &&
    liveblogData.navsubsecs.subsec1.subsecname1
  ) {
    const section = liveblogData.navsubsecs.subsec1.subsecname1.toUpperCase();
    return pageSections[section] ? pageSections[section] : pageSections.DEFAULT;
  }
  if (
    isMobile &&
    breadcrumbData &&
    breadcrumbData.length > 1 &&
    breadcrumbData[1].link
  ) {
    const section = breadcrumbData[1].link.replace('/', '').toUpperCase();
    return pageSections[section] ? pageSections[section] : pageSections.DEFAULT;
  }
  return pageSections.DEFAULT;
};
//  gadgets news, auto/launches, auto/cars, nri, religion main parents id's
export const subSectionIds = [
  '66949542',
  '50466790',
  '74317216',
  '7098551',
  '79795437',
  '5880659',
];
export const SECTIONARRAY = [
  'world',
  'city',
  'nri',
  'religion',
  'auto',
  'gadgetsnews',
  'tech',
];

export const adBlockerStatus = {
  ENABLED: 1,
  DISABLED: 0,
};

export const getCustomDimension45 = publishedDate => {
  const todayDate = new Date();
  const diff = Math.round(
    (todayDate - new Date(Number(publishedDate))) / (1000 * 60 * 60 * 24),
  );
  return diff;
};

const handleScrollDepth = (containerSelector, callback, justinitialized) => {
  const element = document.querySelector(containerSelector);
  if (element) {
    const elementRec = element.getBoundingClientRect();
    const elementPosition = Math.abs(elementRec.top);

    const scrolledPercentage = parseFloat(
      elementPosition / (elementRec.height - window.innerHeight) * 100,
    );
    if (justinitialized) {
      callback(-1, containerSelector);
    } else {
      callback(
        scrolledPercentage > 100 ? 100 : scrolledPercentage,
        containerSelector,
      );
    }
  }
};

export const monitorScrollDepth = (
  containerSelector,
  callback,
  justinitialized,
) =>
  debounce(
    () => handleScrollDepth(containerSelector, callback, justinitialized),
    100,
  );

export const addScrollListener = (containerSelector, callback) => {
  window.addEventListener(
    'scroll',
    monitorScrollDepth(containerSelector, callback),
  );
};
export const removeScrollListener = (containerSelector, callback) => {
  window.removeEventListener(
    'scroll',
    monitorScrollDepth(containerSelector, callback),
  );
};
export const fireGaOnblur = callback => {
  'beforeunload'.split(' ').forEach(e => {
    window.addEventListener(e, callback, false);
  });
};

export const removeFireGaOnblur = callback => {
  'beforeunload'.split(' ').forEach(e => {
    window.removeEventListener(e, callback, false);
  });
};

export const getScrollPerPageDimensions = (
  container,
  dimesnsionCurpgArr,
  dimensionObj,
) => {
  const element = document.querySelector(container);
  if (element) {
    const elementRec = element.getBoundingClientRect();
    const elementTop = Math.abs(elementRec.top);
    dimesnsionCurpgArr.current.forEach(innerElement => {
      const separatorElemLower = document.querySelector(`#${innerElement}`);
      const separatorElemLowerTop =
        Math.abs(separatorElemLower.getBoundingClientRect().top) +
        document.documentElement.scrollTop -
        document.documentElement.clientTop;
      const innerElementIndex = innerElement.replace('separator', '');
      if (innerElementIndex === '1') {
        const updatedPercentage =
          (elementTop + window.innerHeight) / separatorElemLowerTop * 100;
        if (
          typeof dimensionObj.current[innerElementIndex] === 'undefined' ||
          dimensionObj.current[innerElementIndex] < updatedPercentage
        ) {
          dimensionObj.current[innerElementIndex] =
            updatedPercentage > 100 ? 100 : updatedPercentage || 0;
        }
      } else {
        const separatorElemUpper = document.querySelector(
          `#separator${innerElementIndex - 1}`,
        );
        const separatorElemUpperTop =
          separatorElemUpper.getBoundingClientRect().top +
          document.documentElement.scrollTop -
          document.documentElement.clientTop;
        const updatedPercentage =
          (elementTop - separatorElemUpperTop + window.innerHeight) /
          (separatorElemLowerTop - separatorElemUpperTop) *
          100;
        if (
          typeof dimensionObj.current[innerElementIndex] === 'undefined' ||
          dimensionObj.current[innerElementIndex] < updatedPercentage
        ) {
          dimensionObj.current[innerElementIndex] =
            updatedPercentage > 100 ? 100 : updatedPercentage || 0;
        }
      }
    });
  }
};
// to support old implementation of read and up next
export const getGRxParams = () => {
  let grxParam = '?';
  const grxId = getCookie('_grx');
  grxParam = grxId ? `${grxParam}grxid=${grxId}&` : grxParam;
  const ssoid = getCookie('ssoid') || getCookie('ssoId');
  grxParam = ssoid ? `${grxParam}ssoid=${ssoid}&` : grxParam;
  if (typeof window !== 'undefined') {
    const msid = getMsidFromPath(window.location.href);
    grxParam = msid ? `${grxParam}msid=${msid}&` : grxParam;
  }
  return grxParam;
};

export function capitalizeFirstLowercaseRest(str) {
  if (str && typeof str === 'string') {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  return '';
}

export const getPublishedTime = timestamp => {
  const date = new Date(parseInt(timestamp, 10));
  const hours = `0${date.getHours()}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);
  return `${hours}:${minutes}`;
};

export const getPublishedDate = timestamp => {
  const date = new Date(parseInt(timestamp, 10));
  const day = `0${date.getDate()}`.slice(-2);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const zodiacSigns = [
  'aries',
  'taurus',
  'gemini',
  'cancer',
  'leo',
  'virgo',
  'libra',
  'scorpio',
  'sagittarius',
  'capricorn',
  'aquarius',
  'pisces',
];

export const zodiacSubpage = ['daily', 'weekly', 'monthly'];

export const getPageTemplate = () => {
  let pageTemplate = 'listpage';
  try {
    if (window.location.pathname?.includes('/astrology/horoscope')) {
      pageTemplate = 'sunsign_showpage';
    }
    if (window.location.pathname?.includes('/videos/shorts')) {
      pageTemplate = 'shorts_listing';
    }
    if (window.location.pathname?.includes('/live-tv')) {
      pageTemplate = 'live_tv';
    }
    if (window.location.pathname.indexOf('/articleshow/') >= 0) {
      pageTemplate = 'Articleshow';
    }
    if (window.location.pathname.indexOf('/articleshow_comments/') >= 0) {
      pageTemplate = 'commentdetail';
    }
    if (
      window.location.pathname?.includes('aqi-level-air-quality-index-today')
    ) {
      pageTemplate = 'aqi';
    }
    if (window.location.pathname?.includes('life-style/bmi-calculator')) {
      pageTemplate = 'bmi';
    }
    if (window.location.pathname?.includes('-weather-forecast-today')) {
      pageTemplate = 'city_weather';
    }

    if (window.location.pathname.indexOf('/sip-calculator') >= 0) {
      pageTemplate = 'SIP';
    }
    if (window.location.pathname.indexOf('/emi-calculator') >= 0) {
      pageTemplate = 'EMI';
    }
    if (window.location.pathname.indexOf('/videoshow/') >= 0) {
      pageTemplate = 'Videoshow';
    }
    if (window.location.pathname.indexOf('/liveblog/') >= 0) {
      pageTemplate = 'Liveblog';
    }
    if (window.location.pathname.indexOf('/amazon-bestsellers') >= 0) {
      pageTemplate = 'amazon-bestsellers';
    }
    if (window.location.pathname.indexOf('/featureshow/') >= 0) {
      pageTemplate = 'featureshow';
    }
    if (window.location.pathname.indexOf('/forum/') >= 0) {
      pageTemplate = 'forum';
    }
    if (window.location.pathname.indexOf('/photostory/') >= 0) {
      pageTemplate = 'photostory';
    }
    if (
      pageTemplate === 'listpage' &&
      window.App.gaData.dimension9 === 'Home'
    ) {
      pageTemplate = 'home';
    }
    if (window.location.pathname?.includes('/business/markets')) {
      const pathArray = window.location.pathname.split('/');
      if (pathArray && pathArray.length === 4 && pathArray[2] === 'stocks' && pathArray[3] !== '') {
        pageTemplate = 'stock_show';
      } else if (pathArray && pathArray.length === 4 && pathArray[2] === 'etfs' && pathArray[3] !== '') {
        pageTemplate = 'etf_show';
      } else if (pathArray && pathArray.length === 2 && pathArray[1] === 'markets') {
        pageTemplate = 'market_listing';
      }
    }
    if (pageTemplate === 'listpage') {
      pageTemplate = 'listing';
      if (window.location.href.indexOf('/constituency-show') > 0) {
        pageTemplate = `Constituency Show`;
      }
      if (window.location.href.indexOf('/constituencies-list') > 0) {
        pageTemplate = `Constituency Listing`;
      }
      if (window.location.href.indexOf('/astrology/compatibility/') > 0) {
        pageTemplate = `compatibility_showpage`;
      }
    }
  } catch (error) {
    pageTemplate = 'listpage';
  }
  return pageTemplate;
};

export const getLocalStorageValue = (name) => {
  let value = '';
  if (name && typeof localStorage === 'object') {
    try {
      value = localStorage.getItem(name);
    } catch (err) {
      console.warn(err);
    }
  }
  if (!value) {
    value = getCookie(name);
  }
  return value;
};

const CheckMediaEmbeds = articleData => {
  const checkIsArrayandLength = media => {
    if (media && Array.isArray(media) && media.length > 0) {
      return true;
    }
    return false;
  };
  const checkInlineAudio = audio => {
    if (audio && Array.isArray(audio) && audio.length > 0) {
      const isInlineAudioPresent = audio.filter(
        item => item.type === 'inlineaudio',
      );
      return isInlineAudioPresent.length > 0;
    }
    return false;
  };

  const checkInlineVideo = video => {
    if (video && Array.isArray(video) && video.length > 0) {
      const isInlineVideoPresent = video.filter(
        item => item.type === 'inlinevideo',
      );
      return isInlineVideoPresent.length > 0;
    }
    return false;
  };
  switch (!!articleData) {
    case checkIsArrayandLength(articleData.audios) &&
      checkIsArrayandLength(articleData.videos):
      return 'video, audio';
    case checkIsArrayandLength(articleData.audios) &&
      checkInlineVideo(articleData.story):
      return 'video, audio';
    case checkIsArrayandLength(articleData.videos) &&
      checkInlineAudio(articleData.story):
      return 'video, audio';
    case checkInlineVideo(articleData.story) &&
      checkInlineAudio(articleData.story):
      return 'video, audio';
    case checkIsArrayandLength(articleData.audios) ||
      checkInlineAudio(articleData.story):
      return 'audio';
    case checkIsArrayandLength(articleData.videos) ||
      checkInlineVideo(articleData.story):
      return 'video';
    default:
      return 'N/A';
  }
};

export const fireGA4Script = ({
  vmsid = '',
  categorytabsmetainfo = 'N/A',
  storyNumber = '',
  isToipLayout = false,
  page_template = '',
  params = {},
  dayssincecreated = '',
  isEtimesHome = false,
  contentType = '',
} = {}) => {
  let dataLayer;
  if (typeof window !== 'undefined') {
    const msid = `${vmsid}`;
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    let pageTemplate = 'listpage';
    let perpetual = false;
    let pagination = '';
    let sectionName = '';
    let subsectionName = '';
    let subsection2Name = '';
    let articleId = '';
    let metaKeywords = '';
    let channelName = '';
    let daysCreated = dayssincecreated || '';
    let isPaywalled = false;
    let primeContent = false;
    let subsec3 = '';
    let subsec4 = '';
    let subsExperienceType;
    let mediaEmbed;
    // eslint-disable-next-line no-nested-ternary
    const browsingPlatform = window?.App?.state?.isFrmapp
      ? 'webview'
      : window.App.state.isMobile ? 'mweb' : 'web';
    const browsingClient = 'web';
    const prc = getCookie('prc');
    const userPrcDataFromSession = JSON.parse(
      sessionStorage.getItem(`prime_${prc}`),
    );
    const checkSunsignPage = window.location.pathname.split('/');
    const zodiacsubsectionName =
      checkSunsignPage &&
      Array.isArray(checkSunsignPage) &&
      checkSunsignPage.length > 3 &&
      checkSunsignPage[3]
        ? checkSunsignPage[3]
        : '';
    const stockMarketTemplates = {
      '/business/stock-market-holidays/settlement-clearing-holidays':
        'clearance_market_holidays',
      '/business/stock-market-holidays/mcx-holidays': 'mcx_holidays',
      '/business/stock-market-holidays/bse-holidays': 'bse_holidays',
      '/business/stock-market-holidays/nse-holidays': 'nse_holidays',
      '/business/stock-market-holidays': 'stock_market_holidays',
    };
    if (
      location.pathname?.includes('/astrology/horoscope') &&
      zodiacSigns.includes(zodiacsubsectionName)
    ) {
      pageTemplate = 'sunsign_showpage';
    }
    if (window.location.pathname?.includes('/videos/shorts')) {
      pageTemplate = 'shorts_listing';
    }
    if (window.location.pathname?.includes('/live-tv')) {
      pageTemplate = 'live_tv';
    }
    if (window.location.pathname?.includes('/greetingshow/')) {
      pageTemplate = 'greetingshow';
    }
    if (window.location.pathname?.includes('/business/markets')) {
      const pathArray = window.location.pathname.split('/');
      if (pathArray && pathArray.length === 5 && pathArray[3] === 'stocks' && pathArray[4] !== '') {
        pageTemplate = 'stock_show';
      } else if (pathArray && pathArray.length === 5 && pathArray[3] === 'etfs' && pathArray[4] !== '') {
        pageTemplate = 'etf_show';
      } else if (pathArray && pathArray.length === 3 && pathArray[2] === 'markets') {
        pageTemplate = 'market_listing';
      }
    }
    if (location.pathname.indexOf('/articleshow/') >= 0) {
      pageTemplate = 'Articleshow';
      perpetual = !isToipLayout;
      pagination = storyNumber ? `p${storyNumber}` : `p0`;
    }
    if (location.pathname?.includes('aqi-level-air-quality-index-today')) {
      pageTemplate = 'aqi';
    }
    if (location.pathname?.includes('gold-rates-today')) {
      const pathArray = window.location.pathname.split('/');
      if (pathArray && pathArray.length === 4 && pathArray[3] !== '') {
        pageTemplate = 'gold_city_page';
      } else {
        pageTemplate = 'gold_landing_page';
      }
    }
    if (location.pathname?.includes('silver-rates-today')) {
      const pathArray = window.location.pathname.split('/');
      if (pathArray && pathArray.length === 4 && pathArray[3] !== '') {
        pageTemplate = 'silver_city_page';
      } else {
        pageTemplate = 'silver_landing_page';
      }
    }
    if (location.pathname?.includes('platinum-rates-today')) {
      const pathArray = window.location.pathname.split('/');
      if (pathArray && pathArray.length === 4 && pathArray[3] !== '') {
        pageTemplate = 'platinum_city_page';
      } else {
        pageTemplate = 'platinum_landing_page';
      }
    }
    if (location.pathname?.includes('ifsc-code')) {
      const pathArray = window.location.pathname.split('/');
      if (
        pathArray &&
        pathArray.length > 6 &&
        pathArray[5] !== '' &&
        pathArray[6] !== ''
      ) {
        pageTemplate = 'ifsc_result_page';
      } else if (pathArray && pathArray.length === 3 && pathArray[3] !== '') {
        pageTemplate = 'ifsc_bank_page';
      } else {
        pageTemplate = 'ifsc_code_landing';
      }
    }
    if (location.pathname?.includes('life-style/bmi-calculator')) {
      pageTemplate = 'bmi';
    }
    if (location.pathname?.includes('-weather-forecast-today')) {
      pageTemplate = 'city_weather';
    }
    if (location.pathname?.includes('/business/stock-market-holidays')) {
      pageTemplate =
        Object.entries(stockMarketTemplates).find(([key]) =>
          location.pathname?.includes(key),
        )?.[1] || pageTemplate;
    }
    if (location.pathname === '/weather') {
      pageTemplate = 'weather_aqi';
    }
    if (location.pathname.indexOf('/sip-calculator') >= 0) {
      pageTemplate = 'SIP';
    }
    if (location.pathname.indexOf('/emi-calculator') >= 0) {
      pageTemplate = 'EMI';
    }
    if (location.pathname.indexOf('/videoshow/') >= 0) {
      pageTemplate = 'Videoshow';
    }
    if (location.pathname.indexOf('/liveblog/') >= 0) {
      pageTemplate = 'Liveblog';
    }
    if (location.pathname.indexOf('/movie-review/') >= 0) {
      pageTemplate = 'moviereviewshow';
    }
    if (location.pathname.indexOf('/webseriesshow/') >= 0) {
      pageTemplate = 'series_show';
    }
    if (location.pathname.indexOf('/seasonshow/') >= 0) {
      pageTemplate = 'series_season_show';
    }
    if (location.pathname.indexOf('/episodeshow/') >= 0) {
      pageTemplate = 'series_episode_show';
    }
    if (location.pathname.indexOf('/ottmoviereview/') >= 0) {
      pageTemplate = 'ottmoviereviewshow';
    }
    if (location.pathname.indexOf('/amazon-bestsellers') >= 0) {
      pageTemplate = 'amazon-bestsellers';
    }
    if (location.pathname.indexOf('/featureshow/') >= 0) {
      pageTemplate = 'featureshow';
    }
    if (location.pathname.indexOf('/forum/') >= 0) {
      pageTemplate = 'forum';
    }
    if (location.pathname.indexOf('/articleshow_comments/') >= 0) {
      pageTemplate = 'commentdetail';
    }
    if (location.pathname.indexOf('/photostory/') >= 0) {
      pageTemplate = 'photostory';
      perpetual = true;
      const photoIndex = params && params.photoNumber ? params.photoNumber : 1;
      pagination = storyNumber
        ? `p${storyNumber}${photoIndex > 1 ? `_${photoIndex}` : ''}`
        : `p0${photoIndex > 1 ? `_${photoIndex}` : ''}`;
      if (window?.App?.state?.photostory?.data[msid]?.metaInfo?.Contenttype) {
        contentType =
          window?.App?.state?.photostory?.data[msid]?.metaInfo?.Contenttype;
      }
    }
    if (
      pageTemplate === 'listpage' &&
      (window.App.gaData.dimension9 === 'Home' || isEtimesHome)
    ) {
      pageTemplate = 'home';
    }

    // Added Extra code here
    if (pageTemplate === 'listpage') {
      const pathArray = window.location.pathname.split('/');
      sectionName = pathArray && pathArray[1] ? pathArray[1] : '';
      sectionName = capitalizeFirstLowercaseRest(sectionName);
      subsectionName = pathArray && pathArray[2] ? pathArray[2] : '';
      subsectionName = capitalizeFirstLowercaseRest(subsectionName);
      subsection2Name = pathArray && pathArray[3] ? pathArray[3] : '';
      subsection2Name = capitalizeFirstLowercaseRest(subsection2Name);
      if (sectionName === 'Videos') {
        sectionName = subsectionName;
        subsectionName =
          pathArray && Array.isArray(pathArray) && pathArray[3]
            ? pathArray[3]
            : '';
        subsectionName = capitalizeFirstLowercaseRest(subsectionName);
      }
      if (subsectionName === 'Dontgetscammed') {
        subsection2Name =
          pathArray && Array.isArray(pathArray) && pathArray[3]
            ? pathArray[3]
            : '';
        subsection2Name = capitalizeFirstLowercaseRest(subsection2Name);
      }
      if (location.pathname === '/life-style/fashion/jewellery') {
        subsection2Name =
          pathArray && Array.isArray(pathArray) && pathArray[3]
            ? pathArray[3]
            : '';
        subsection2Name = capitalizeFirstLowercaseRest(subsection2Name);
      }

      subsec3 =
        pathArray && Array.isArray(pathArray) && pathArray[3]
          ? pathArray[3]
          : '';
      subsec4 =
        pathArray && Array.isArray(pathArray) && pathArray[4]
          ? pathArray[4]
          : '';
      if (
        subsec3 &&
        subsec3 === 'how-to-watch-ipl-cricket-live-streaming-online'
      ) {
        subsectionName = subsec4 || subsec3;
      }

      if (window?.App?.state?.newslisting?.data?.details?.contentType) {
        contentType =
          window?.App?.state?.newslisting?.data?.details?.contentType;
      }

      metaKeywords = document?.head?.querySelector('meta[name=keywords]')
        ?.content;
    } else if (
      // Article show
      window?.App?.state?.isArticleshow &&
      pageTemplate !== 'listpage'
    ) {
      articleId = msid || window?.App?.state?.articleshow_v2?.activemsid;
      sectionName = window?.App?.state?.articleshow_v2?.data[articleId]
        ?.navsubsecs?.subsec1?.subsecname1
        ? window?.App?.state?.articleshow_v2?.data[articleId]?.navsubsecs
            ?.subsec1?.subsecname1
        : '';
      subsectionName = window?.App?.state?.articleshow_v2?.data[articleId]
        ?.navsubsecs?.subsec2?.subsecname2
        ? window?.App?.state?.articleshow_v2?.data[articleId]?.navsubsecs
            ?.subsec2?.subsecname2
        : '';
      subsection2Name = window?.App?.state?.articleshow_v2?.data[articleId]
        ?.navsubsecs?.subsec3?.subsecname3
        ? window?.App?.state?.articleshow_v2?.data[articleId]?.navsubsecs
            ?.subsec3?.subsecname3
        : '';
      metaKeywords = window?.App?.state?.articleshow_v2?.data[articleId]?.seo
        ?.keywords
        ? window?.App?.state?.articleshow_v2?.data[articleId]?.seo?.keywords
        : '';
      daysCreated = window?.App?.state?.articleshow_v2?.data[articleId]?.dl
        ? window?.App?.state?.articleshow_v2?.data[articleId]?.dl
        : '';
      contentType = window?.App?.state?.articleshow_v2?.data[articleId]
        ?.metaInfo?.Contenttype
        ? window?.App?.state?.articleshow_v2?.data[articleId]?.metaInfo
            ?.Contenttype
        : '';
      mediaEmbed = CheckMediaEmbeds(
        window?.App?.state?.articleshow_v2?.data[articleId],
      );
    } else if (pageTemplate === 'aqi') {
      const pathArray = window.location.pathname.split('/');
      sectionName =
        pathArray &&
        Array.isArray(pathArray) &&
        pathArray?.length > 1 &&
        pathArray[1]
          ? pathArray[1]
          : '';
      sectionName = capitalizeFirstLowercaseRest(sectionName);
      const subsectionNameFormat =
        pathArray &&
        Array.isArray(pathArray) &&
        pathArray?.length > 2 &&
        pathArray[2] &&
        pathArray[2].split('-aqi-level-air-quality-index-today')[0];
      subsectionName = pathArray && pathArray[2] ? subsectionNameFormat : '';
      subsectionName = capitalizeFirstLowercaseRest(subsectionName);
    } else if (pageTemplate === 'bmi') {
      sectionName = 'life-style';
      subsectionName = 'health_fitness';
    } else if (pageTemplate === 'weather_aqi') {
      sectionName = 'weather';
      subsectionName = 'weather_aqi_landing';
      contentType = 'data_page';
    } else if (pageTemplate === 'city_weather') {
      const pathArray = window.location.pathname.split('/');
      sectionName =
        pathArray &&
        Array.isArray(pathArray) &&
        pathArray?.length > 1 &&
        pathArray[1]
          ? pathArray[1]
          : '';
      sectionName = capitalizeFirstLowercaseRest(sectionName);
      const subsectionNameFormat =
        pathArray &&
        Array.isArray(pathArray) &&
        pathArray?.length > 2 &&
        pathArray[2] &&
        pathArray[2].split('-weather-forecast-today')[0];
      subsectionName = pathArray && pathArray[2] ? subsectionNameFormat : '';
      subsectionName = capitalizeFirstLowercaseRest(subsectionName);
    } else if (
      // Live Blogs
      (window?.App?.state?.isLiveblog || window?.App?.state?.isLiveblogV2) &&
      pageTemplate !== 'listpage'
    ) {
      articleId = window?.App?.state?.liveblog_v2?.completeTimelineData?.msid;
      sectionName = window?.App?.state?.liveblog_v2?.navsubsecs?.subsec1
        ?.subsecname1
        ? window?.App?.state?.liveblog_v2?.navsubsecs?.subsec1?.subsecname1
        : '';
      subsectionName = window?.App?.state?.liveblog_v2?.navsubsecs?.subsec2
        ?.subsecname2
        ? window?.App?.state?.liveblog_v2?.navsubsecs?.subsec2?.subsecname2
        : '';
      subsection2Name = window?.App?.state?.liveblog_v2?.navsubsecs?.subsec3
        ?.subsecname3
        ? window?.App?.state?.liveblog_v2?.navsubsecs?.subsec3?.subsecname3
        : '';
      metaKeywords = window?.App?.state?.liveblog_v2?.seo?.keywords
        ? window?.App?.state?.liveblog_v2?.seo?.keywords
        : '';
      daysCreated = window?.App?.state?.liveblog_v2?.dl
        ? window?.App?.state?.liveblog_v2?.dl
        : '';
      contentType = window?.App?.state?.liveblog_v2?.metaInfo?.Contenttype
        ? window?.App?.state?.liveblog_v2?.metaInfo?.Contenttype
        : '';
    } else if (
      // Video Show
      window?.App?.state?.videoshow?.videoData &&
      pageTemplate !== 'listpage'
    ) {
      articleId = window?.App?.state?.videoshow?.videoData?.msid;
      const parts = window.location.pathname.split('/');
      if (Array.isArray(parts) && parts.length > 0) {
        let filteredParts = parts.filter(part => part !== '');
        if (filteredParts.length > 0 && filteredParts[0] === 'videos') {
          filteredParts.shift();
        }
        const index = filteredParts.findIndex(part => part === 'videoshow');
        filteredParts =
          index !== -1 ? filteredParts.slice(0, index) : filteredParts;
        if (
          filteredParts &&
          Array.isArray(filteredParts) &&
          filteredParts.length > 0
        ) {
          filteredParts.pop();
          sectionName = filteredParts.length > 0 ? filteredParts[0] : '';
          subsectionName = filteredParts.length > 1 ? filteredParts[1] : '';
          sectionName = sectionName.replace('-', '_');
          subsectionName = subsectionName.replace('-', '_');
        } else {
          subsectionName = '';
          sectionName = '';
        }
      } else {
        subsectionName = '';
        sectionName = '';
      }

      metaKeywords = window?.App?.state?.videoshow?.videoData?.seoData?.data
        ?.keywords
        ? window?.App?.state?.videoshow?.videoData?.seoData?.data?.keywords
        : '';
      daysCreated = window?.App?.state?.videoshow?.videoData?.datePublishedMedia
        ? window?.App?.state?.videoshow?.videoData?.datePublishedMedia
        : '';
      contentType = window?.App?.state?.videoshow?.videoData?.seoData?.data
        ?.Contenttype
        ? window?.App?.state?.videoshow?.videoData?.seoData?.data?.Contenttype
        : '';
    } else if (
      // Video Show - New Feed
      window?.App?.state?.videoshow?.videoshowData &&
      pageTemplate !== 'listpage'
    ) {
      articleId = window?.App?.state?.videoshow?.videoshowData?.id;
      const parts = window.location.pathname.split('/');
      if (Array.isArray(parts) && parts.length > 0) {
        let filteredParts = parts.filter(part => part !== '');
        if (filteredParts.length > 0 && filteredParts[0] === 'videos') {
          filteredParts.shift();
        }
        const index = filteredParts.findIndex(part => part === 'videoshow');
        filteredParts =
          index !== -1 ? filteredParts.slice(0, index) : filteredParts;
        if (
          filteredParts &&
          Array.isArray(filteredParts) &&
          filteredParts.length > 0
        ) {
          filteredParts.pop();
          sectionName = filteredParts.length > 0 ? filteredParts[0] : '';
          subsectionName = filteredParts.length > 1 ? filteredParts[1] : '';
          sectionName = sectionName.replace('-', '_');
          subsectionName = subsectionName.replace('-', '_');
        } else {
          subsectionName = '';
          sectionName = '';
        }
      } else {
        subsectionName = '';
        sectionName = '';
      }

      metaKeywords = window?.App?.state?.videoshow?.videoshowData?.pwa_meta?.key
        ? window.App.state.videoshow.videoshowData.pwa_meta.key
        : '';
      if (window?.App?.state?.videoshow?.videoshowData) {
        const leadVideo = window?.App?.state?.videoshow?.videoshowData.items;
        if (Array.isArray(leadVideo) && leadVideo.length) {
          daysCreated =
            leadVideo[0] && leadVideo[0].unixtimesstamp
              ? leadVideo[0].unixtimesstamp
              : '';
        }
      }
    } else if (
      // Feature Show
      window?.App?.state?.featureshow &&
      window?.App?.state?.featureshow?.data &&
      pageTemplate !== 'listpage'
    ) {
      articleId = msid;
      sectionName = window?.App?.state?.featureshow?.data[articleId]?.navsubsecs
        ?.subsec1?.subsecname1
        ? window?.App?.state?.featureshow?.data[articleId]?.navsubsecs?.subsec1
            ?.subsecname1
        : '';
      subsectionName = window?.App?.state?.featureshow?.data[articleId]
        ?.navsubsecs?.subsec2?.subsecname2
        ? window?.App?.state?.featureshow?.data[articleId]?.navsubsecs?.subsec2
            ?.subsecname2
        : '';
      subsection2Name = window?.App?.state?.featureshow?.data[articleId]
        ?.navsubsecs?.subsec3?.subsecname3
        ? window?.App?.state?.featureshow?.data[articleId]?.navsubsecs?.subsec3
            ?.subsecname3
        : '';
      metaKeywords = window?.App?.state?.featureshow?.data[articleId]?.seo
        ?.keywords
        ? window?.App?.state?.featureshow?.data[articleId]?.seo?.keywords
        : '';
      daysCreated = window?.App?.state?.featureshow?.data[articleId]?.dl
        ? window?.App?.state?.featureshow?.data[articleId]?.dl
        : '';
      contentType = window?.App?.state?.featureshow?.data[articleId]?.metaInfo
        ?.Contenttype
        ? window?.App?.state?.featureshow?.data[articleId]?.metaInfo
            ?.Contenttype
        : '';
    } else if (window?.App?.state?.featureshow && window?.App?.state?.discussionforum?.data && pageTemplate !== 'listpage') {
      articleId = msid;
      sectionName = window?.App?.state?.discussionforum?.data[articleId]?.navsubsecs
        ?.subsec1?.subsecname1
        ? window?.App?.state?.discussionforum?.data[articleId]?.navsubsecs?.subsec1
            ?.subsecname1
        : '';
      subsectionName = window?.App?.state?.discussionforum?.data[articleId]
        ?.navsubsecs?.subsec2?.subsecname2
        ? window?.App?.state?.discussionforum?.data[articleId]?.navsubsecs?.subsec2
            ?.subsecname2
        : '';
      subsection2Name = window?.App?.state?.discussionforum?.data[articleId]
        ?.navsubsecs?.subsec3?.subsecname3
        ? window?.App?.state?.discussionforum?.data[articleId]?.navsubsecs?.subsec3
            ?.subsecname3
        : '';
      metaKeywords = window?.App?.state?.discussionforum?.data[articleId]?.seo
        ?.keywords
        ? window?.App?.state?.discussionforum?.data[articleId]?.seo?.keywords
        : '';
      daysCreated = window?.App?.state?.discussionforum?.data[articleId]?.dl
        ? window?.App?.state?.discussionforum?.data[articleId]?.dl
        : '';
      contentType = window?.App?.state?.discussionforum?.data[articleId]?.metaInfo
        ?.Contenttype
        ? window?.App?.state?.discussionforum?.data[articleId]?.metaInfo
            ?.Contenttype
        : '';
    } else if (
      pageTemplate === 'moviereviewshow' ||
      pageTemplate === 'ottmoviereviewshow'
    ) {
      articleId = msid;
      sectionName = window?.App?.state?.moviereview?.data[articleId]?.navsubsecs
        ?.subsec1?.subsecname1
        ? window?.App?.state?.moviereview?.data[articleId]?.navsubsecs?.subsec1
            ?.subsecname1
        : '';
      subsectionName = window?.App?.state?.moviereview?.data[articleId]
        ?.navsubsecs?.subsec2?.subsecname2
        ? window?.App?.state?.moviereview?.data[articleId]?.navsubsecs?.subsec2
            ?.subsecname2
        : '';
      subsection2Name = window?.App?.state?.moviereview?.data[articleId]
        ?.navsubsecs?.subsec3?.subsecname3
        ? window?.App?.state?.moviereview?.data[articleId]?.navsubsecs?.subsec3
            ?.subsecname3
        : '';
      metaKeywords = window?.App?.state?.moviereview?.data[articleId]?.seo
        ?.keywords
        ? window?.App?.state?.moviereview?.data[articleId]?.seo?.keywords
        : '';
      contentType = window?.App?.state?.moviereview?.data[articleId]?.metaInfo
        ?.Contenttype
        ? window?.App?.state?.moviereview?.data[articleId]?.metaInfo
            ?.Contenttype
        : '';
    } else {
      // Default
      const pathArray = window.location.pathname.split('/');
      sectionName = pathArray && pathArray[1] ? pathArray[1] : '';
      sectionName = capitalizeFirstLowercaseRest(sectionName);
      subsectionName = pathArray && pathArray[2] ? pathArray[2] : '';
      subsectionName = capitalizeFirstLowercaseRest(subsectionName);

      metaKeywords = document?.head?.querySelector('meta[name=keywords]')
        ?.content;
    }

    if (pageTemplate === 'listpage') {
      pageTemplate = 'listing';
      if (window.location.href.indexOf('/constituency-show') > 0) {
        pageTemplate = `Constituency Show`;
      }
      if (window.location.href.indexOf('/constituencies-list') > 0) {
        pageTemplate = `Constituency Listing`;
      }
      if (window.location.href.indexOf('/astrology/compatibility/') > 0) {
        pageTemplate = `compatibility_showpage`;
      }
    }

    if (sectionName !== '') {
      if (
        sectionName === 'entertainment' ||
        sectionName === 'Entertainment' ||
        sectionName === 'etimes' ||
        sectionName === 'Etimes' ||
        sectionName === 'Lifestyle' ||
        sectionName === 'lifestyle'
      ) {
        channelName = 'Etimes';
      } else if (
        (sectionName === 'Videos' && subsectionName === 'Auto') ||
        sectionName === 'Auto'
      ) {
        channelName = 'AN';
      } else if (sectionName === 'Technology') {
        channelName = 'GN';
      } else {
        channelName = 'toi';
      }
    } else {
      channelName = 'toi';
    }
    if (
      window.location.href.indexOf('/gadgets-news/') > -1 ||
      window.location.href.indexOf('/technology/') > -1
    ) {
      channelName = 'GN';
    }
    if (
      window.location.href.indexOf('/web-series/') > -1 ||
      window.location.href.indexOf('/life-style/') > -1 ||
      window.location.href.indexOf('/tv/') > -1
    ) {
      channelName = 'Etimes';
    }
    if (window.location.href.indexOf('/food-news/') > -1) {
      channelName = 'recipe';
    }

    if (sectionName === 'Life & Style') {
      sectionName = 'life_style';
    }
    if (
      getStringToLowerCase(sectionName) === 'spotlight' ||
      getStringToLowerCase(subsectionName) === 'spotlight' ||
      getStringToLowerCase(pageTemplate) === 'liveblog' ||
      getStringToLowerCase(pageTemplate) === 'videoshow'
    ) {
      perpetual = false;
      pagination = 'N/A';
    }
    if (
      sectionName === '' &&
      getStringToLowerCase(subsectionName) === 'spotlight'
    ) {
      sectionName = subsectionName;
      subsectionName = '';
    }
    if (window.location.href.indexOf('/auto/') >= 0) {
      channelName = 'AN';
    }

    if (isToipLayout) {
      primeContent = true;
      if (window?.App?.state?.isArticleshow) {
        const primeId =
          window.App?.state?.articleshow_v2?.data[articleId]?.primeid;
        if (primeId === PAID_ARTICLE_PRIME_ID && !window.App?.state?.isPrime) {
          isPaywalled = true;
        }
        pagination = 'N/A';
      } else {
        pagination = storyNumber ? `p${storyNumber}` : 'N/A';
        pageTemplate = page_template || 'TOIPlus Listing';
      }
    }

    if (window?.App?.state?.isPrime) {
      if (
        window?.App?.state?.isArticleshow ||
        pageTemplate === 'home' ||
        window?.App?.state?.isLiveblogV2
      ) {
        subsExperienceType = 'NEW_v1.3.0';
      }
    }

    if (window?.App?.state?.isArticleshow) {
      const primeId =
        window.App?.state?.articleshow_v2?.data[articleId]?.primeid;
      primeContent = isPrimeContent(primeId);
      if (
        primeId === FREE_ARTICLE_PRIME_ID ||
        primeId === FREE_ARTICLE_PRIME_ID_NUMBER
      ) {
        subsExperienceType = 'NEW_v1.2.1';
        perpetual = false;
      }
    }

    if (params.frmEtimes) {
      channelName = 'etimes';
    }
    if (window.location.href.indexOf('/life-style/travel') >= 0) {
      channelName = 'travel';
    }
    if (location.pathname?.includes('/games/')) {
      const urlParams = new URLSearchParams(window.location.search);
      const isIframe = urlParams.get('isiframe') === 'true';
      const source = urlParams.get('source');
      if (isIframe && source) {
        channelName = source;
      }
    }
    if (
      window?.App?.state?.ipl_live_static &&
      window?.App?.state?.ipl_live_static.data &&
      window?.App?.state?.ipl_live_static.data.metaInfo &&
      window?.App?.state?.ipl_live_static.data.metaInfo.Contenttype
    ) {
      contentType =
        window?.App?.state?.ipl_live_static.data.metaInfo.Contenttype;
    }
    if (params.contentType) {
      contentType = params.contentType;
    }

    if (pageTemplate === 'home' && isEtimesHome) {
      sectionName = '';
    }
    if (pageTemplate === 'amazon-bestsellers') {
      sectionName = '';
    }
    if (params?.isGameplayPage) {
      pageTemplate = 'gameplay';
    } else if (params?.isGamesPracticePage) {
      pageTemplate = 'games_practice';
    } else if (params?.isGamesResultPage) {
      pageTemplate = 'games_result_view';
    }
    const ssoid = getCookie('ssoid');
    const grxId = getCookie('_grx');
    dataLayer = window.dataLayer || [];
    

    // ---------- Helper to build user details object ----------
    let isUserLoggedOut = false;
    let userId;
    // Safely read logout state
    if (window.sessionStorage) {
      isUserLoggedOut = sessionStorage.getItem('isUserLoggedOut') === '1';
    }
    if (ssoid) {
      userId = ssoid;
    } else if (isUserLoggedOut) {
      userId = 'null';
    }
    const buildUserDetailsPayload = (extra = {}) => {
      let loginStatus = 'false';
        if (ssoid) {
          loginStatus = 'true';
        } else if (getLocalStorageValue('emhash') || getLocalStorageValue('phhash')) {
          loginStatus = 'known';
        } else {
          loginStatus = 'false';
        }
        return {
          ...(userId !== undefined ? { sso_id: userId, user_id: userId } : {}),
          prime_user: ssoid ? getPrcCookieValue() : -1,
          prime_status: window?.App?.state?.isPrime ?? null,
          login_status: loginStatus,
          user_grx_id: grxId || 'N/A',
        }
    };
    const dataObject = {
      event: 'page_view',
      //page_title: document.title,
      page_template: getStringToLowerCase(pageTemplate),
      authors: window.App.gaData.dimension4
        ? getStringToLowerCase(window.App.gaData.dimension4)
        : 'N/A',
      agency: window.App.gaData.dimension5
        ? getStringToLowerCase(window.App.gaData.dimension5)
        : 'N/A',
      section: sanitizeSectionName(getStringToLowerCase(sectionName)) || 'N/A',
      subsection:
        sanitizeSectionName(getStringToLowerCase(subsectionName)) || 'N/A',
      subsection2:
        sanitizeSectionName(getStringToLowerCase(subsection2Name)) || 'N/A',
      msid: msid || (articleId || 'N/A'),
      keywords: metaKeywords || 'N/A',
      browsing_platform: getStringToLowerCase(browsingPlatform),
      browsing_client: getStringToLowerCase(browsingClient),
      business_property: getStringToLowerCase(channelName) || 'N/A',
      user_agent: typeof window !== 'undefined' && window?.navigator?.userAgent
      ? window.navigator.userAgent
      : 'N/A',
      page_stack: 'react',
      perpetual,
      pagination: pagination || 'N/A',
      network: connection?.effectiveType
        ? getStringToLowerCase(connection?.effectiveType)
        : 'N/A',
      // login_status: ssoid ? 'true' : 'false',
      days_since_created:
        daysCreated !== '' ? getCustomDimension45(daysCreated) : 'N/A',
      //new values
      //prime_user: ssoid ? getPrcCookieValue() : -1,
      // ...(ssoid ? { sso_id: ssoid } : {}),
      // user_grx_id: grxId || 'N/A',
      meta_tag: metaKeywords || 'N/A',
      prime_content: primeContent,
      is_paywalled: isPaywalled,
      published_time:
        daysCreated !== '' ? getPublishedTime(daysCreated) : 'N/A',
      published_date:
        daysCreated !== '' ? getPublishedDate(daysCreated) : 'N/A',
      section_full:
        getStringToLowerCase(
          [sectionName, subsectionName, subsec3, subsec4]
            .filter(Boolean)
            .join('_'),
        ) || 'N/A',
      subscription_source: userPrcDataFromSession?.subscriptionSource || 'N/A',
      plan_name: userPrcDataFromSession?.planName || 'N/A',
      content_type:
        contentType !== '' ? getStringToLowerCase(contentType) : 'N/A',
      page_version: getStringToLowerCase(sectionName) === 'auto' ? 'v1' : 'N/A',
      category_tag: categorytabsmetainfo
        ? getStringToLowerCase(categorytabsmetainfo)
        : 'N/A',
      ...(subsExperienceType
        ? { subs_experience_type: subsExperienceType }
        : {}),
      network_speed: window?.navigator?.connection?.downlink || 'N/A',
      media_embed: mediaEmbed || 'N/A',
      ...buildUserDetailsPayload(),
    };

    if (isToipLayout) {
      return dataObject;
    }

    if (
      params?.isGameplayPage ||
      params?.isGamesPracticePage ||
      params?.isGamesResultPage
    ) {
      dataObject.game_of_the_day = window.location.href
        .toLowerCase()
        .includes('/today');
    }

  
    dataLayer.push(dataObject);

    dataLayer.push({
      event: 'user_details_manual',
      ...(userId !== undefined ? { sso_id: userId, user_id: userId } : {}),
      ...buildUserDetailsPayload(),
    });

    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        const dataObject2 = {
          ...dataObject,
          navigation_type: 'back_forward_cache',
        };
        dataLayer.push(dataObject2);

        dataLayer.push({
          event: 'user_details_manual',
          ...buildUserDetailsPayload(),
        });
      }
    });
    // fireMonetizationDetailEvent();
  }

  // console.log(
  //   'window',
  //   window?.document && document.cookie.match(/(?:\s)?ssoid=(\w+);?/),
  // );
  return dataLayer;
};

export const fireGA4ScriptPerpectual = ({
  vmsid = '',
  storyNumber = '',
  sectionName = '',
  subSection = '',
  authorName = '',
  agencyName = '',
  dayssincecreated = '',
  dlTimeStamp = '',
  isToipLayout = false,
  contentType = '',
} = {}) => {
  const storyId = vmsid;
  const userCookie = document.cookie.match(/(?:\s)?ssoid=(\w+);?/);
  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;
  let pageTemplate = 'listpage';
  let perpetual = false;
  let pagination = '';
  let channelName = '';
  let subsExperienceType;
  const daysCreated = dayssincecreated;
  const metaKeywords = document.head
    .getElementsByTagName('meta')
    .keywords.getAttribute('content');
  // eslint-disable-next-line no-nested-ternary
  const browsingPlatform = window.App.state.isFrmapp
    ? 'webview'
    : window.App.state.isMobile ? 'mweb' : 'web';
  const prc = getCookie('prc');
  const userPrcDataFromSession = JSON.parse(
    sessionStorage.getItem(`prime_${prc}`),
  );
  if (location.pathname.indexOf('/articleshow/') >= 0) {
    pageTemplate = 'Articleshow';
    perpetual = true;
    pagination = storyNumber ? `p${storyNumber}` : 'p0';
  }
  if (location.pathname.indexOf('/videoshow/') >= 0) {
    pageTemplate = 'Videoshow';
    pagination = 'N/A';
  }
  if (location.pathname.indexOf('/liveblog/') >= 0) {
    pageTemplate = 'Liveblog';
  }
  if (location.pathname.indexOf('/photostory/') >= 0) {
    pageTemplate = 'photostory';
  }
  if (location.pathname.indexOf('/movie-review/') >= 0) {
    pageTemplate = 'moviereviewshow';
  }
  if (location.pathname.indexOf('/ottmoviereview/') >= 0) {
    pageTemplate = 'ottmoviereviewshow';
  }
  if (sectionName !== '') {
    if (
      sectionName === 'entertainment' ||
      sectionName === 'Entertainment' ||
      sectionName === 'etimes' ||
      sectionName === 'Etimes' ||
      sectionName === 'Lifestyle' ||
      sectionName === 'lifestyle'
    ) {
      channelName = 'Etimes';
    } else {
      channelName = 'toi';
    }
  } else {
    channelName = window?.Times?.adsKeys?.Channel
      ? window.Times.adsKeys.Channel
      : '';
  }
  if (
    window.location.href.indexOf('/gadgets-news/') > -1 ||
    window.location.href.indexOf('/technology/') > -1
  ) {
    channelName = 'GN';
  }
  if (
    window.location.href.indexOf('/web-series/') > -1 ||
    window.location.href.indexOf('/life-style/') > -1 ||
    window.location.href.indexOf('/tv/') > -1
  ) {
    channelName = 'Etimes';
  }
  if (window.location.href.indexOf('/food-news/') > -1) {
    channelName = 'recipe';
  }

  if (sectionName === 'Life & Style') {
    sectionName = 'life_style';
  }
  if (sectionName === '' && getStringToLowerCase(subSection) === 'spotlight') {
    sectionName = subSection;
    subSection = '';
  }
  if (window.location.href.indexOf('/auto/') >= 0) {
    channelName = 'AN';
  }
  if (window.location.href.indexOf('/life-style/travel') >= 0) {
    channelName = 'travel';
  }
  // let userType = false;
  // let prcpval = '';
  // if (userCookie) {
  //   prcpval = document.cookie.match(/(?:\s)?prc=(\w+);?/)[1];
  //   if (prcpval === 5) {
  //     userType = true;
  //   }
  // }

  if (window?.App?.state?.isPrime) {
    if (
      window?.App?.state?.isArticleshow ||
      pageTemplate === 'home' ||
      window?.App?.state?.isLiveblogV2
    ) {
      subsExperienceType = 'NEW_v1.1.0';
    }
  }

  const ssoid = getCookie('ssoid');
  const grxId = getCookie('_grx');

  // ---------- Helper to build user details object ----------
  let isUserLoggedOut = false;
  let userId;
  // Safely read logout state
  if (window.sessionStorage) {
    isUserLoggedOut = sessionStorage.getItem('isUserLoggedOut') === '1';
  }
  if (ssoid) {
    userId = ssoid;
  } else if (isUserLoggedOut) {
    userId = 'null';
  }
  const buildUserDetailsPayload = (extra = {}) => {
    let loginStatus = 'false';
    if (ssoid) {
      loginStatus = 'true';
    } else if (getLocalStorageValue('emhash') || getLocalStorageValue('phhash')) {
      loginStatus = 'known';
    } else {
      loginStatus = 'false';
    }
    return {
      ...(userId !== undefined ? { sso_id: userId, user_id: userId } : {}),
      prime_user: ssoid ? getPrcCookieValue() : -1,
      prime_status: window?.App?.state?.isPrime ?? null,
      login_status: loginStatus,
      user_grx_id: grxId || 'N/A',
    }
  };
  // eslint-disable-next-line no-unused-expressions
  window.dataLayer = window.dataLayer || [];
  const dataObject = {
    event: 'page_view',
    //page_title: document.title,
    page_template: getStringToLowerCase(pageTemplate),
    authors: getStringToLowerCase(authorName) || 'N/A',
    agency: getStringToLowerCase(agencyName) || 'N/A',
    section: getStringToLowerCase(sectionName) || 'N/A',
    subsection: getStringToLowerCase(subSection) || 'N/A',
    msid: storyId,
    keywords: metaKeywords || 'N/A',
    browsing_platform: getStringToLowerCase(browsingPlatform),
    business_property: getStringToLowerCase(channelName) || 'N/A',
    user_agent: typeof window !== 'undefined' && window?.navigator?.userAgent
    ? window.navigator.userAgent
    : 'N/A',
    page_stack: 'react',
    // prime_content: false,
    perpetual,
    pagination: pagination || 'N/A',
    network: connection?.effectiveType
      ? getStringToLowerCase(connection?.effectiveType)
      : 'N/A',
    // login_status: userCookie ? 'true' : 'false',
    days_since_created: daysCreated !== '' ? daysCreated : 'N/A',
    // new-values
    // prime_user: ssoid ? getPrcCookieValue() : -1,
    // ...(userCookie ? { sso_id: userCookie } : {}),
    // user_grx_id: grxId || 'N/A',
    meta_tag: metaKeywords || 'N/A',
    prime_content: isToipLayout,
    is_paywalled: false,
    published_time: dlTimeStamp !== '' ? getPublishedTime(dlTimeStamp) : 'N/A',
    published_date: dlTimeStamp !== '' ? getPublishedDate(dlTimeStamp) : 'N/A',
    section_full:
      getStringToLowerCase(
        [sectionName, subSection].filter(Boolean).join('_'),
      ) || 'N/A',
    subscription_source: userPrcDataFromSession?.subscriptionSource || 'N/A',
    plan_name: userPrcDataFromSession?.planName || 'N/A',
    content_type:
      contentType !== '' ? getStringToLowerCase(contentType) : 'N/A',
    ...(subsExperienceType ? { subs_experience_type: subsExperienceType } : {}),
    ...buildUserDetailsPayload(),
  };
  if (isToipLayout) {
    return dataObject;
  }
  // eslint-disable-next-line no-undef
  dataLayer.push(dataObject);
  
  // eslint-disable-next-line no-undef
  dataLayer.push({
    event: 'user_details_manual',
    ...buildUserDetailsPayload(),
  });
  // fireMonetizationDetailEvent();
  // eslint-disable-next-line no-undef
  return dataLayer;
};
// ends here
// to support new implementation of read and up next(native reducer)
export const appendGrxParams = (url, articleId) => {
  let grxParam = url.indexOf('?') < 0 ? '?' : '&';
  const grxId = getCookie('_grx');
  grxParam = grxId ? `${grxParam}grxid=${grxId}&` : grxParam;
  const ssoid = getCookie('ssoid') || getCookie('ssoId');
  grxParam = ssoid ? `${grxParam}ssoid=${ssoid}&` : grxParam;
  if (typeof window !== 'undefined') {
    const msid = articleId || getMsidFromPath(window.location.href);
    grxParam = msid ? `${grxParam}msid=${msid}&` : grxParam;
  }
  return url + grxParam;
};

// We are maintaining an array of max 10 msid
export const setViewedArticleMsidsInLocalStorage = msid => {
  let articleMsids = [];
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    articleMsids = JSON.parse(localStorage.getItem('articlesViewed'));
    if (Array.isArray(articleMsids) && articleMsids.length) {
      articleMsids = [...new Set([...articleMsids, msid])];
      if (articleMsids.length > 10) {
        articleMsids.shift();
      }
    } else {
      articleMsids = [...new Set([msid])];
    }
    localStorage.setItem('articlesViewed', JSON.stringify(articleMsids));
  }
  return articleMsids.join(',');
};
export const getGrxObject = (data = {}) => {
  const {
    hasWarning = false,
    body = {},
    apiUrl,
    signalEventType,
    algorithm_version,
    apiStatus,
    slotName,
  } = data;
  return {
    hasWarning,
    slotName,
    body,
    apiCalled: apiUrl,
    signalEventType,
    algorithm_version,
    apiStatus,
  };
};
export const isGrxIdEmpty = (url, apiStatus, slotName) => {
  const grxId = getQueryParams('grxid', { href: url });
  if (!grxId) {
    const body = {
      code: GRXID_ABSENT_ERROR_CODE,
      message: GRXID_ABSENT_ERROR_MESSAGE,
      msid: [],
    };
    const grxInfo = getGrxObject({ apiStatus, body, apiUrl: url, slotName });
    return grxInfo;
  }
  return false;
};

export function checkInlineTemplate(itemLink = '') {
  let itemType = 'link_others';
  if (typeof itemLink !== 'string') {
    return itemType;
  }
  if (
    itemLink?.indexOf('timesofindia.indiatimes.com') !== -1 &&
    itemLink?.indexOf('/articleshow/') !== -1
  ) {
    itemType = 'link_article';
  } else if (
    itemLink?.indexOf('timesofindia.indiatimes.com') !== -1 &&
    itemLink?.indexOf('/videoshow/') !== -1
  ) {
    itemType = 'link_video';
  } else if (
    itemLink?.indexOf('timesofindia.indiatimes.com') !== -1 &&
    itemLink?.indexOf('/liveblog/') !== -1
  ) {
    itemType = 'link_liveblog';
  } else if (
    itemLink?.indexOf('timesofindia.indiatimes.com') !== -1 &&
    itemLink?.indexOf('/photostory/') !== -1
  ) {
    itemType = 'link_photostory';
  }
  return itemType;
}

export const enableNewGooglExtended = () => {
  if (
    typeof window !== 'undefined' &&
    window.sessionStorage &&
    sessionStorage.getItem('newGeAccessKey')
  ) {
    return true;
  }
  return true;
};

const getPixelsFromTop = ele => {
  const eleRect = ele?.getBoundingClientRect();
  const elePixelsFromTop = eleRect?.top + window.scrollY;
  return elePixelsFromTop;
};

export const calculatePixelsFromParent = (parent, child) => {
  const parentPixels = getPixelsFromTop(parent);
  const childPixels = getPixelsFromTop(child);
  if (!parent) {
    return childPixels;
  }
  return childPixels - parentPixels;
};

export const setSignalDataInLocalStorage = data => {
  if (typeof localStorage === 'object') {
    const signalsData = JSON.stringify(data);
    localStorage.setItem('signalsInfo', signalsData);
  }
};
const removeSignalDataFromLocalStorage = () => {
  localStorage.removeItem('signalsInfo');
};
export const getSignalDataFromLocalStorage = () => {
  const data = localStorage.getItem('signalsInfo');
  removeSignalDataFromLocalStorage();
  return data && JSON.parse(data);
};
export const getSsoidAndTicket = () => {
  const ticketId =
    getCookie('TicketId') || getCookie('Ticketid') || getCookie('ticketId');
  const ssoId = getCookie('ssoid') || getCookie('ssoId');

  return {
    ticketId,
    ssoId,
  };
};

export const getHash = str => {
  let hash = 0;
  let givenStr = str;
  let i;
  let chr;
  if (str.length === 0) return hash;
  givenStr = givenStr.substr(0, 1500);
  for (i = 0; i < givenStr.length; i += 1) {
    chr = str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + chr;
    // eslint-disable-next-line no-bitwise
    hash |= 0; // Convert to 32bit integer
  }
  return `${hash}_${Math.floor(Math.random() * 100 + 1)}`;
};

export const getParsedJson = reqJson => {
  let json = reqJson;
  try {
    json = JSON.parse(reqJson);
    // eslint-disable-next-line no-empty
  } catch (err) {}
  return json;
};

const visitedSet = new Set();
export const markAsVisited = msid => {
  if (msid) {
    visitedSet.add(msid);
  }
  return visitedSet;
};

export const mergeGrxObj = (grxObj, failureObj) => {
  if (!Object.keys(failureObj).length) {
    return grxObj;
  }
  const grxBody = JSON.parse(grxObj?.body);
  const code = `${failureObj?.code}||${grxBody?.code}`;
  const message = `${failureObj?.message}||${grxBody?.message}`;
  grxBody.code = code;
  grxBody.message = message;
  grxObj.body = JSON.stringify(grxBody);
  return grxObj;
};

const personalisewidget = {
  readNextVariants: {
    readNextRowVariant: 'SignalsReadNext__CardCarousel',
    readNextColumnVariant: 'SignalsReadNext__ThreeRowsManyColsCarousel',
  },
};

export const getwidgetInfo = (readNextVariants, apidata) => {
  const data = personalisewidget[readNextVariants];
  const keys = Object.keys(data);
  let infoObj = {};
  keys.forEach(key => {
    if (apidata && apidata[data[key]]) {
      infoObj = {
        widgetToRender: key,
        dataToRender: apidata[data[key]],
      };
    }
  });
  return infoObj;
};

export const retryGrxTrackCall = (func, timeout = 1000) => {
  const intervalId = setInterval(() => {
    if (
      typeof window.grx_module !== 'undefined' &&
      typeof window.grx === 'function'
    ) {
      func();
      clearInterval(intervalId);
    }
  }, timeout);
};

export const postCreditScoreMessage = userData => {
  try {
    const iframe = document.getElementById('creditscoreiframe');
    if (
      iframe &&
      iframe.contentWindow &&
      typeof iframe.contentWindow.postMessage === 'function'
    ) {
      const messageData = `{
      "first_name": ${
        userData &&
        userData.isLoggedIn &&
        typeof userData.getFirstName === 'function'
          ? `"${userData.getFirstName()}"`
          : null
      },
      "last_name": ${
        userData &&
        userData.isLoggedIn &&
        typeof userData.getLastName === 'function'
          ? `"${userData.getLastName()}"`
          : null
      },
      "mobile_number": null,
      "source": "timesofindia"
    }`;
      const iframeOrigin = '*';
      iframe.contentWindow.postMessage(messageData, iframeOrigin);
    }
  } catch (err) {
    console.log(err);
  }
};

export const getJarvisFeedURL = (
  path,
  params = '',
  forceClientSide = false,
) => {
  const isClientSide = typeof window !== 'undefined';
  let dbEnv = __PROD__
    ? 'db_env=published'
    : `db_env=drafts&${JARVIS_CACHE_BY_PASS}`;

  let clientJarvisFeedURL = JARVIS_FEED_URL;
  if (isClientSide) {
    const { location: { href = '' } = {} } = window;
    if (href.includes('vsp1jarvis=yes')) {
      clientJarvisFeedURL = clientJarvisFeedURL.replace(
        'jarvis.',
        'vsp1jarvis.',
      );
    }
    if (href.includes('jarvisdraftsdb=yes')) {
      dbEnv = dbEnv.replace('db_env=published', 'db_env=drafts');
    }
  }

  const domain =
    isClientSide || forceClientSide ? clientJarvisFeedURL : JARVIS_PVT_FEED_URL;

  const finalURL = `${domain + path}?${dbEnv}${params}`;
  return finalURL;
};

export const fireGA4WithDataObject = dataObject => {
  if (typeof window !== 'undefined') {
    const dataLayer = window.dataLayer || [];
    if (dataObject) {
      dataLayer.push(dataObject);
    }
    // fireMonetizationDetailEvent();
  }
};

export const collectEventfireGa4 = (objTosend, objToMap = {}) => {
  // eslint-disable-next-line no-prototype-builtins
  if (
    Object.prototype.hasOwnProperty.call(objToMap, 'item_id') &&
    !objToMap.item_id
  ) {
    delete objToMap.item_id;
  }
  const gaEventObj = {
    ...objTosend,
    items: [
      {
        ...objToMap,
      },
    ],
  };
  fireGA4WithDataObject(gaEventObj);
  const { event, ...restgaEventObj } = gaEventObj;
  return { ...restgaEventObj };
};

export const getGa4PageViewSet = () => {
  if (Array.isArray(window.dataLayer) && window.dataLayer.length > 0) {
    const fileteredArray = window.dataLayer.filter(
      obj => obj.event === 'page_view',
    );
    if (Array.isArray(fileteredArray) && fileteredArray.length > 0) {
      return fileteredArray[0];
    }
    return {};
  }
  return {};
};

export const msToTime = duration => {
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor(duration / (1000 * 60 * 60));

  const pad = num => (num < 10 ? '0' : '') + num;

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export const formatDate = timestamp => {
  const date = new Date(timestamp);

  // Get today's date
  const today = new Date(); //1995-12-17T03:24:00
  today.setHours(0, 0, 0, 0);

  // Get yesterday's date
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Compare with today's and yesterday's date
  if (date >= today) {
    return 'Today';
  } else if (date >= yesterday) {
    return 'Yesterday';
  }
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};

export const padVideoDurationTimestamp = time => {
  if (time) {
    const [hours, minutes] = time.split(':').map(Number);
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');
    return `${paddedHours}:${paddedMinutes}`;
  }
  return time;
};

// Function to get the start of the day for a given date
const startOfDay = date => {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  return start;
};

// Function to format a date to "Y-m-d"
const formatDateGA = date => date.toISOString().split('T')[0];

// Function to compare two dates in "Y-m-d" format
export const areDatesEqual = (date1, date2) =>
  formatDateGA(date1) === formatDateGA(date2);
export const getCurrentDateFormatted = (
  dateString,
  format = 'full',
  time = false,
) => {
  let date;
  if (dateString) {
    const [day, month, year] = dateString.split('-').map(Number);
    date = new Date(year, month - 1, day);
  } else {
    date = new Date();
  }
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  let hour = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  const formattedTime =
    minutes === 0 ? `${hour}:00${ampm}` : `${hour}:${minutes}${ampm}`;
  const monthNamesAbbreviated = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const month = monthNamesAbbreviated[monthIndex];

  const getOrdinalSuffix = days => {
    if (days > 3 && days < 21) return 'th';
    switch (days % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  const formattedDay = `${day}${getOrdinalSuffix(day)}`;
  if (format === 'dd-mm' || format === 'DD-MM') {
    const formattedDays = day < 10 ? `0${day}` : `${day}`;
    const formattedMonth = month + 1 < 10 ? `0${month + 1}` : `${month + 1}`;

    return `${formattedDays}-${formattedMonth}`;
  }
  if (dateString && !time && format === 'day-month') {
    return `${formattedDay} ${month}`;
  }
  if (time) {
    return `${formattedDay} ${month} ${year}, ${formattedTime}`;
  }
  return `${formattedDay} ${month} ${year}`;
};

export const stockTypeLinks = {
  name: 'Trending News',
  ga4Type: 'trending_seo_news_pills',
  items: [
    {
      hl: 'Stock Markets Holidays',
      wu: `${TOI_LIVE_DOMAIN}/business/stock-market-holidays`,
      id: 1,
      target: '_blank',
    },
    {
      hl: 'NSE Holidays',
      wu: `${TOI_LIVE_DOMAIN}/business/stock-market-holidays/nse-holidays`,
      id: 1,
      target: '_blank',
    },
    {
      hl: 'BSE Holidays',
      wu: `${TOI_LIVE_DOMAIN}/business/stock-market-holidays/bse-holidays`,
      id: 2,
      target: '_blank',
    },
    {
      hl: 'MCX Holidays',
      wu: `${TOI_LIVE_DOMAIN}/business/stock-market-holidays/mcx-holidays`,
      id: 3,
      target: '_blank',
    },
    {
      hl: 'Settlement/Clearance Holidays',
      wu: `${TOI_LIVE_DOMAIN}/business/stock-market-holidays/settlement-clearing-holidays`,
      id: 4,
      target: '_blank',
    },
  ],
};
export const holidayStateList = [
  {
    name: 'Andaman & Nicobar',
    shortUrl: 'andaman-and-nicobar',
  },
  {
    name: 'Andhra Pradesh',
    shortUrl: 'andhra-pradesh',
  },
  {
    name: 'Arunachal Pradesh',
    shortUrl: 'arunachal-pradesh',
  },
  {
    name: 'Assam',
    shortUrl: 'assam',
  },
  {
    name: 'Bihar',
    shortUrl: 'bihar',
  },
  {
    name: 'Chandigarh',
    shortUrl: 'chandigarh',
  },
  {
    name: 'Chhattisgarh',
    shortUrl: 'chhattisgarh',
  },
  {
    name: 'Dadra and Nagar Haveli',
    shortUrl: 'dadra-and-nagar-haveli',
  },
  {
    name: 'Daman and Diu',
    shortUrl: 'daman-and-diu',
  },
  {
    name: 'Delhi',
    shortUrl: 'delhi',
  },
  {
    name: 'Goa',
    shortUrl: 'goa',
  },
  {
    name: 'Gujarat',
    shortUrl: 'gujarat',
  },
  {
    name: 'Haryana',
    shortUrl: 'haryana',
  },
  {
    name: 'Himachal Pradesh',
    shortUrl: 'himachal-pradesh',
  },
  {
    name: 'Jammu and kashmir',
    shortUrl: 'jammu-and-kashmir',
  },
  {
    name: 'Jharkhand',
    shortUrl: 'jharkhand',
  },
  {
    name: 'Karnataka',
    shortUrl: 'karnataka',
  },
  {
    name: 'Kerala',
    shortUrl: 'kerala',
  },
  {
    name: 'Lakshadweep',
    shortUrl: 'lakshadweep',
  },
  // {
  //   name: 'Ladakh',
  //   shortUrl: 'ladakh',
  // },
  {
    name: 'Madhya Pradesh',
    shortUrl: 'madhya-pradesh',
  },
  {
    name: 'Maharashtra',
    shortUrl: 'maharashtra',
  },
  {
    name: 'Manipur',
    shortUrl: 'manipur',
  },
  {
    name: 'Meghalaya',
    shortUrl: 'meghalaya',
  },
  {
    name: 'Mizoram',
    shortUrl: 'mizoram',
  },
  {
    name: 'Nagaland',
    shortUrl: 'nagaland',
  },
  {
    name: 'Odisha',
    shortUrl: 'odisha',
  },
  {
    name: 'Puducherry',
    shortUrl: 'puducherry',
  },
  {
    name: 'Punjab',
    shortUrl: 'punjab',
  },
  {
    name: 'Rajasthan',
    shortUrl: 'rajasthan',
  },
  {
    name: 'Sikkim',
    shortUrl: 'sikkim',
  },
  {
    name: 'Tamil Nadu',
    shortUrl: 'tamil-nadu',
  },
  {
    name: 'Telangana',
    shortUrl: 'telangana',
  },
  {
    name: 'Tripura',
    shortUrl: 'tripura',
  },
  {
    name: 'Uttar Pradesh',
    shortUrl: 'uttar-pradesh',
  },
  {
    name: 'Uttarakhand',
    shortUrl: 'uttarakhand',
  },
  {
    name: 'West Bengal',
    shortUrl: 'west-bengal',
  },
];
export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const generateHolidayLinkData = type => {
  const baseUrl =
    type === 'bank'
      ? `${TOI_LIVE_DOMAIN}/business/bank-holidays`
      : `${TOI_LIVE_DOMAIN}/india/public-holidays`;

  return {
    stateData: holidayStateList.map(stateitem => ({
      name: stateitem.name,
      shortUrl: `${baseUrl}/${stateitem.shortUrl}`,
    })),
    monthData: monthNames.map(monthitem => ({
      name: monthitem,
      monthUrl: `${baseUrl}/${monthitem.toLowerCase()}`,
    })),
  };
};

export const roundNumber = num => {
  if (num === undefined || num === null) {
    return '-';
  }
  if (typeof num === 'string') {
    num = parseFloat(num);
    if (isNaN(num)) {
      return '-'; // Return NaN if the string is not a valid number
    }
  }
  if (typeof num !== 'number' || isNaN(num)) {
    return '-'; // Return NaN if the input is invalid
  }

  const decimalPart = num % 1;
  if (decimalPart >= 0.5) {
    return Math.ceil(num);
  }
  return Math.floor(num);
};

export function getIncrementalMaxAge(date) {
  let maxAge = 259200; // 3days default maxAge
  try {
    const newdate = parseInt(date, 10) || 0;
    const given = startOfDay(new Date(newdate));

    // Current date
    const current = startOfDay(new Date());

    // Difference in number of days
    const diffInMillis = current - given;
    const diffDays = diffInMillis / (1000 * 60 * 60 * 24);

    if (diffDays >= 365) {
      maxAge = 31536000; // 365 days maxAge
    } else if (diffDays < 365 && diffDays > 3) {
      maxAge = 2628004; // 30 days maxAge
    }
    return maxAge;
  } catch (err) {
    return maxAge;
  }
}

export const getIbeatContentType = (pageType, isPhotostory) => {
  let iBeatcontentType = 20;
  switch (pageType) {
    case 'LIVEBLOG':
      iBeatcontentType = 99;
      break;
    case 'ARTICLESHOW':
      iBeatcontentType = isPhotostory ? 3 : 1;
      break;
    default:
      break;
  }
  return iBeatcontentType;
};

export const maskPhoneNumber = phoneNumber => {
  // If the number starts with a country code (+XX), extract the country code
  const countryCodeMatch = phoneNumber.match(/^(\+\d{1,3})?(\d{6})(\d{4})$/);

  if (countryCodeMatch) {
    const countryCode = countryCodeMatch[1] || ''; // The country code if present
    const last4Digits = countryCodeMatch[3]; // The last 4 digits of the phone number
    return `${countryCode}******${last4Digits}`; // Mask the middle 6 digits
  }

  return phoneNumber;
};

export const maskEmail = email => {
  const [username, domain] = email.split('@');

  if (username && username.length > 2) {
    const firstChar = username[0];
    const lastChar = username[username.length - 1];
    const maskedUsername = `${firstChar}*****${lastChar}`;
    return `${maskedUsername}@${domain || 's'}`;
  }
  // If username is too short, return the original email without masking
  return email;
};

export const cityNameMap = {
  allahabad: 'prayagraj',
  aurangabad: 'chhatrapati sambhajinagar',
  Allahabad: 'Prayagraj',
  Aurangabad: 'Chhatrapati Sambhajinagar',
};

export const cityNameMapreverse = {
  prayagraj: 'allahabad',
  'chhatrapati sambhajinagar': 'aurangabad',
};

export const getSectionForPathName = (pathname, ind = 1) => {
  if (!(pathname && typeof pathname === 'string')) {
    return '';
  }
  try {
    // Extract pathname if it's a full URL
    const path = pathname.startsWith('http')
      ? new URL(pathname).pathname
      : pathname;

    return path?.split('/')?.[ind];
  } catch (err) {
    // console.error('Error in getSectionForPathName:', err);
    return '';
  }
};

export const getCategoryForVisualStory = url => {
  let section;
  if (url.indexOf(TOI_LIVE_DOMAIN) > -1) {
    section = getSectionForPathName(url);
  } else if (url.indexOf('https://recipes.timesofindia.com/') > -1) {
    section = 'Food';
  } else if (url.indexOf('https://gadgetsnow.indiatimes.com') > -1) {
    section = 'Gadgets';
  } else {
    section = 'india';
  }

  switch (section) {
    case 'life-style':
      section = 'Lifestyle';
      break;
    case 'entertainment':
      section = 'Entertainment';
      break;
    case 'web-stories':
      section = 'Web Stories';
      break;
    default:
      break;
  }
  return section;
};

export const getCloudServiceItemUrl = item => {
  const urlMapping = {
    309: 'https://recipes.timesofindia.com',
    259: 'https://timesofindia.indiatimes.com/travel',
    83: 'https://timesofindia.indiatimes.com',
    34: 'https://photogallery.indiatimes.com',
  };
  let url = '';
  if (item.overridelink) {
    url = item.overridelink;
  } else if (item.cmstype === 'MOVIEREVIEW') {
    url = `${urlMapping[item.hostid]}/${item.seopath}/movie-review/${
      item.msid
    }.cms`;
  } else if (item.cmstype === 'PHOTOGALLERYSLIDESHOWSECTION') {
    url = `${urlMapping[item.hostid]}/${item.seopath}/photostory/${
      item.msid
    }.cms`;
  } else if (item.cmstype === 'ARTICLE') {
    url = `${urlMapping[item.hostid]}/${item.seopath}/articleshow/${
      item.msid
    }.cms`;
  } else if (item.cmstype === 'LIVEBLOG') {
    url = `${urlMapping[item.hostid]}/${item.seopath}/liveblog/${
      item.msid
    }.cms`;
  } else if (item.cmstype === 'MEDIAVIDEO') {
    url = `${urlMapping[item.hostid]}/${item.seopath}/videoshow/${
      item.msid
    }.cms`;
  }
  if (item.hostid !== 83 && item.overridelink) {
    url.replace(urlMapping[83], urlMapping[item.hostid]);
  }
  return url;
};

export const addSpeculationRules = (containerClass, eagerness = 'moderate') => {
  if (!document.querySelector('script[type="speculationrules"]')) {
    const script_ = document.createElement('script');
    script_.type = 'speculationrules';
    script_.textContent = `
      {
        "prefetch": [
          {
            "source": "document",
            "where": {
              "selector_matches": ".${containerClass} a"
            },
            "eagerness": "${eagerness}"
          }
        ]
      }
    `;
    document.head.appendChild(script_);
  }
};

export const getSafeUtmParams = (dataURL = "") => {
  try {
    if (typeof window === "undefined") return dataURL; // SSR safety

    const query = window.location.search || "";
    if (!query.startsWith("?")) return dataURL; // no query string

    const params = new URLSearchParams(query);

    ["utm_id", "utm_source", "utm_medium", "utm_campaign"].forEach((key) => {
      const val = params.get(key);
      if (val) {
        dataURL += `${dataURL.includes("?") || dataURL.includes("&") ? "&" : "?"}${key}=${val}`;
      }
    });

    return dataURL; // return final string
  } catch {
    return dataURL; // fallback
  }
};

export const getFormattedBirthdateStr = (birthdateStr) => {
  if (!birthdateStr) return null;
  const [datePart] = birthdateStr.split(' ');
  const [day, month, year] = datePart.split('-');
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];
  const mIndex = parseInt(month, 10) - 1;
  const monthText = monthNames[mIndex] || '';
  return `${day} ${monthText} ${year}`;
};

export const normalizePath = (path) => {
  if(!path){return null}
  return path?.replace(/\/$/, "");
}

export const isSamePath = (apiUrl, currentPath) => {
  if(apiUrl && currentPath){
  const apiPath = normalizePath(new URL(apiUrl)?.pathname);
  const currPath = normalizePath(currentPath);
  return apiPath === currPath;
  }
  return false
}